
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("bDXRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6e95e1106c7e127$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $fhkEb = parcelRequire("fhkEb");

var $lp3dk = parcelRequire("lp3dk");

var $bEEBX = parcelRequire("bEEBX");

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $isIf6 = parcelRequire("isIf6");

var $cLLe3 = parcelRequire("cLLe3");

var $kUJJo = parcelRequire("kUJJo");

var $hA6Wh = parcelRequire("hA6Wh");
const $b6e95e1106c7e127$var$filterAttributesFunction = (0, $isIf6.default).filterAttributes;
const $b6e95e1106c7e127$var$FilterPanel = ({ products: products, skus: skus = [], variant: variant = "", numberOfProducts: numberOfProducts })=>{
    const [mobileFilterVisible, setMobileFilterVisible] = (0, $dvPqk.useState)(false);
    const isDesktop = (0, $gUV6W.default)((0, $5OqMf.twDesktopBreakpoint));
    const resolvedProducts = !(0, $bEEBX.default)(products) ? products : (0, $bZiDo.default).resolveSkus(skus);
    const filterAttributes = $b6e95e1106c7e127$var$filterAttributesFunction(variant);
    (0, $gtsdT.logger).log("search", "Filter attributes", filterAttributes);
    if ((0, $biFcX.default).navigationTestVariant === "megamenu") {
        filterAttributes.brandGroup = "Merkevare";
        if (/ost/g.test(variant)) filterAttributes.format = "Format";
    }
    const allFilters = [];
    const filterKeys = Object.keys(filterAttributes);
    for(let i = 0; i < filterKeys.length; i++){
        const fieldKey = filterKeys[i];
        const fieldName = filterAttributes[fieldKey];
        if ((0, $bEEBX.default)(fieldName)) continue;
        const filter = (0, $luszM.buildFilter)(resolvedProducts, fieldKey, fieldName);
        if (!(0, $bEEBX.default)(filter)) allFilters.push(filter);
    }
    (0, $gtsdT.logger).log("search", "All filters", allFilters);
    const relevantFilters = (0, $luszM.getRelevantFilterSettings)(allFilters, (0, $bZiDo.default).activeFilters, resolvedProducts);
    (0, $dvPqk.useEffect)(()=>{
        for (const filter of relevantFilters){
            const fieldKey = filter.field;
            // a radio button filter must have a value.  If there is no active filter, we set it here
            if (filter.radioDefault && !(0, $bZiDo.default).activeFilters[fieldKey]?.length) (0, $bZiDo.default).addFilterValue(fieldKey, filter.radioDefault);
        }
        const { activeFilters: activeFilters } = (0, $bZiDo.default);
        if (activeFilters) {
            const filtersToReset = Object.keys(activeFilters).filter((key)=>{
                const activeFilter = activeFilters[key];
                if (activeFilter && activeFilter.length > 0 && !relevantFilters.find((relevantFilter)=>relevantFilter.field === key)) return true;
                return false;
            });
            (0, $bZiDo.default).clearFilterFields(filtersToReset);
        }
    }, [
        JSON.stringify(relevantFilters)
    ]);
    (0, $gtsdT.logger).log("search", "Relevant filters", relevantFilters);
    const filterModified = (e, field, value, isRadio)=>{
        if (e.target.checked) {
            if (isRadio) (0, $bZiDo.default).clearFilterFields([
                field
            ]);
            (0, $bZiDo.default).addFilterValue(field, value);
            (0, $6fuyt.sendFilter)(field, value);
        } else if (isRadio) {
            const currentFilterValue = (0, $bZiDo.default).activeFilters[field]?.find((af)=>af && af !== value);
            if (currentFilterValue) (0, $bZiDo.default).removeFilterValue(field, currentFilterValue);
            (0, $bZiDo.default).addFilterValue(field, value);
            (0, $6fuyt.sendFilter)(field, value);
        } else (0, $bZiDo.default).removeFilterValue(field, value);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            !isDesktop && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fhkEb.default), {}),
                        iconPosition: "left",
                        className: "tw-mb-4",
                        onClick: ()=>setMobileFilterVisible(!mobileFilterVisible),
                        children: "Filter"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $kUJJo.default), {
                        title: "Filter",
                        isOpen: mobileFilterVisible,
                        onClose: ()=>setMobileFilterVisible(false),
                        name: "Mobilfilter",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "tw-relative tw-max-h-[65vh] tw-overflow-y-auto",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hA6Wh.default), {
                                        filters: relevantFilters,
                                        onFilterChange: filterModified
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: "tw-sticky tw-bottom-0 tw-left-0 tw-w-full tw-h-12 tw-bg-gradient-to-t tw-from-surface-default tw-pointer-events-none"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-sticky tw-bottom-0 tw-left-0 tw-mt-4",
                                children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cLLe3.default), {
                                    onClick: ()=>setMobileFilterVisible(false),
                                    children: [
                                        "Vis ",
                                        numberOfProducts,
                                        " produkter"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hA6Wh.default), {
                filters: relevantFilters,
                onFilterChange: filterModified
            })
        ]
    });
};
var $b6e95e1106c7e127$export$2e2bcd8739ae039 = (0, $lp3dk.view)($b6e95e1106c7e127$var$FilterPanel);

});
parcelRegister("fhkEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1f875a6cef63054$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");
function $b1f875a6cef63054$var$AdjustmentsHorizontalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $dvPqk.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $dvPqk.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $dvPqk.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
    }));
}
const $b1f875a6cef63054$var$ForwardRef = $dvPqk.forwardRef($b1f875a6cef63054$var$AdjustmentsHorizontalIcon);
var $b1f875a6cef63054$export$2e2bcd8739ae039 = $b1f875a6cef63054$var$ForwardRef;

});

parcelRegister("hA6Wh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2556b437d9566c78$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $9AGLN = parcelRequire("9AGLN");
var $86Bys = parcelRequire("86Bys");

var $2E94Q = parcelRequire("2E94Q");
var $bwNjW = parcelRequire("bwNjW");

var $dFyfh = parcelRequire("dFyfh");

var $bZiDo = parcelRequire("bZiDo");
const $2556b437d9566c78$var$FilterOptions = ({ filters: filters, onFilterChange: onFilterChange })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2E94Q.AnimatePresence), {
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $bwNjW.motion).div, {
            className: "tw-w-full tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-ink-border-subtle",
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            children: [
                filters.map((f)=>Object.keys(f.options).length > 0 ? /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "tw-p-2 first:tw-pt-0 last:tw-pb-0",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                                children: f.name
                            }),
                            f.radioDefault ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $86Bys.RadioGroup), {
                                label: "",
                                className: "tw-text-sm",
                                value: (0, $bZiDo.default).activeFilters[f.field]?.[0] || f.radioDefault,
                                options: Object.keys(f.options).sort().map((optionName)=>({
                                        label: (0, $dFyfh.translateFilterValue)(f.field, optionName),
                                        value: optionName
                                    })),
                                onChange: (e)=>onFilterChange(e, f.field, e.target.value, !!f.radioDefault)
                            }) : Object.keys(f.options).sort().map((optionName)=>{
                                const name = (0, $dFyfh.translateFilterValue)(f.field, optionName);
                                return !!optionName && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                                    className: "tw-m-1 tw-text-sm tw-font-normal",
                                    label: name,
                                    isChecked: (0, $bZiDo.default).isFilterActive(f.field, optionName),
                                    onChange: (e)=>onFilterChange(e, f.field, optionName, !!f.radioDefault)
                                }, optionName);
                            })
                        ]
                    }, f.name) : null),
                filters.length === 0 && /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                    children: "Ingen filtre tilgjengelig"
                })
            ]
        }, "filter-panel")
    });
};
var $2556b437d9566c78$export$2e2bcd8739ae039 = $2556b437d9566c78$var$FilterOptions;

});
parcelRegister("2E94Q", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $c8fd1c68a2ee1f72$export$3ae376d12526dd6f; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $hc7pA = parcelRequire("hc7pA");

var $b24I0 = parcelRequire("b24I0");

var $h27wv = parcelRequire("h27wv");

var $jsGF3 = parcelRequire("jsGF3");

var $5FwIO = parcelRequire("5FwIO");

var $05WYb = parcelRequire("05WYb");

var $7lgsu = parcelRequire("7lgsu");
var $c8fd1c68a2ee1f72$var$getChildKey = function(child) {
    return child.key || "";
};
function $c8fd1c68a2ee1f72$var$updateChildLookup(children, allChildren) {
    children.forEach(function(child) {
        var key = $c8fd1c68a2ee1f72$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $c8fd1c68a2ee1f72$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $dvPqk.Children).forEach(children, function(child) {
        if ((0, $dvPqk.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $c8fd1c68a2ee1f72$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = (0, $ixrLi.__read)((0, $b24I0.useForceUpdate)(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0, $dvPqk.useContext)((0, $5FwIO.LayoutGroupContext)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    var isMounted = (0, $h27wv.useIsMounted)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $c8fd1c68a2ee1f72$var$onlyElements(children);
    var childrenToRender = filteredChildren;
    var exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $dvPqk.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $dvPqk.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    var isInitialRender = (0, $dvPqk.useRef)(true);
    (0, $05WYb.useIsomorphicLayoutEffect)(function() {
        isInitialRender.current = false;
        $c8fd1c68a2ee1f72$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7lgsu.useUnmountEffect)(function() {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $dvPqk.createElement($dvPqk.Fragment, null, childrenToRender.map(function(child) {
        return $dvPqk.createElement((0, $jsGF3.PresenceChild), {
            key: $c8fd1c68a2ee1f72$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    }));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(childrenToRender), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($c8fd1c68a2ee1f72$var$getChildKey);
    var targetKeys = filteredChildren.map($c8fd1c68a2ee1f72$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $dvPqk.createElement((0, $jsGF3.PresenceChild), {
            key: $c8fd1c68a2ee1f72$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $dvPqk.createElement((0, $jsGF3.PresenceChild), {
            key: $c8fd1c68a2ee1f72$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    if ((0, $hc7pA.env) !== "production" && exitBeforeEnter && childrenToRender.length > 1) console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    return $dvPqk.createElement($dvPqk.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $dvPqk.cloneElement)(child);
    }));
};

});
parcelRegister("hc7pA", function(module, exports) {

$parcel$export(module.exports, "env", function () { return $594683042564093f$export$a7b6bc01c63cdfc3; });
/**
 * Browser-safe usage of process
 */ 
var $gWxMD = parcelRequire("gWxMD");
var $594683042564093f$var$defaultEnvironment = "production";
var $594683042564093f$export$a7b6bc01c63cdfc3 = typeof $gWxMD === "undefined" || $gWxMD.env === undefined ? $594683042564093f$var$defaultEnvironment : "production";

});

parcelRegister("b24I0", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $6f37c0557d86d193$export$91db9bc4f8ac944a; });

var $ixrLi = parcelRequire("ixrLi");

var $5GUqn = parcelRequire("5GUqn");

var $dvPqk = parcelRequire("dvPqk");

var $h27wv = parcelRequire("h27wv");
function $6f37c0557d86d193$export$91db9bc4f8ac944a() {
    var isMounted = (0, $h27wv.useIsMounted)();
    var _a = (0, $ixrLi.__read)((0, $dvPqk.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    var forceRender = (0, $dvPqk.useCallback)(function() {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ var deferredForceRender = (0, $dvPqk.useCallback)(function() {
        return (0, $5GUqn.default).postRender(forceRender);
    }, [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("5GUqn", function(module, exports) {

$parcel$export(module.exports, "cancelSync", function () { return $a33afa914b072999$export$d93e9c1fe0553512; });
$parcel$export(module.exports, "flushSync", function () { return $a33afa914b072999$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "getFrameData", function () { return $a33afa914b072999$export$7244445918e670ed; });
$parcel$export(module.exports, "default", function () { return $a33afa914b072999$export$2e2bcd8739ae039; });

var $axfyV = parcelRequire("axfyV");

var $9BHnq = parcelRequire("9BHnq");
const $a33afa914b072999$var$maxElapsed = 40;
let $a33afa914b072999$var$useDefaultElapsed = true;
let $a33afa914b072999$var$runNextFrame = false;
let $a33afa914b072999$var$isProcessing = false;
const $a33afa914b072999$var$frame = {
    delta: 0,
    timestamp: 0
};
const $a33afa914b072999$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $a33afa914b072999$var$steps = $a33afa914b072999$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $9BHnq.createRenderStep)(()=>$a33afa914b072999$var$runNextFrame = true);
    return acc;
}, {});
const $a33afa914b072999$var$sync = $a33afa914b072999$var$stepsOrder.reduce((acc, key)=>{
    const step = $a33afa914b072999$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$a33afa914b072999$var$runNextFrame) $a33afa914b072999$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $a33afa914b072999$export$d93e9c1fe0553512 = $a33afa914b072999$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $a33afa914b072999$var$steps[key].cancel;
    return acc;
}, {});
const $a33afa914b072999$export$cd75ccfd720a3cd4 = $a33afa914b072999$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$a33afa914b072999$var$steps[key].process($a33afa914b072999$var$frame);
    return acc;
}, {});
const $a33afa914b072999$var$processStep = (stepId)=>$a33afa914b072999$var$steps[stepId].process($a33afa914b072999$var$frame);
const $a33afa914b072999$var$processFrame = (timestamp)=>{
    $a33afa914b072999$var$runNextFrame = false;
    $a33afa914b072999$var$frame.delta = $a33afa914b072999$var$useDefaultElapsed ? (0, $axfyV.defaultTimestep) : Math.max(Math.min(timestamp - $a33afa914b072999$var$frame.timestamp, $a33afa914b072999$var$maxElapsed), 1);
    $a33afa914b072999$var$frame.timestamp = timestamp;
    $a33afa914b072999$var$isProcessing = true;
    $a33afa914b072999$var$stepsOrder.forEach($a33afa914b072999$var$processStep);
    $a33afa914b072999$var$isProcessing = false;
    if ($a33afa914b072999$var$runNextFrame) {
        $a33afa914b072999$var$useDefaultElapsed = false;
        (0, $axfyV.onNextFrame)($a33afa914b072999$var$processFrame);
    }
};
const $a33afa914b072999$var$startLoop = ()=>{
    $a33afa914b072999$var$runNextFrame = true;
    $a33afa914b072999$var$useDefaultElapsed = true;
    if (!$a33afa914b072999$var$isProcessing) (0, $axfyV.onNextFrame)($a33afa914b072999$var$processFrame);
};
const $a33afa914b072999$export$7244445918e670ed = ()=>$a33afa914b072999$var$frame;
var $a33afa914b072999$export$2e2bcd8739ae039 = $a33afa914b072999$var$sync;

});
parcelRegister("axfyV", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", function () { return $95fc20075148544b$export$f8caf8121275292d; });
$parcel$export(module.exports, "onNextFrame", function () { return $95fc20075148544b$export$4fdea63ab5513fd5; });
const $95fc20075148544b$export$f8caf8121275292d = 1 / 60 * 1000;
const $95fc20075148544b$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $95fc20075148544b$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($95fc20075148544b$var$getCurrentTime()), $95fc20075148544b$export$f8caf8121275292d);

});

parcelRegister("9BHnq", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $5613d2526b3e7584$export$b995e5e85f5c8289; });
function $5613d2526b3e7584$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});


parcelRegister("h27wv", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", function () { return $76724d93b3883284$export$80c2a3957bcb42ea; });

var $dvPqk = parcelRequire("dvPqk");

var $05WYb = parcelRequire("05WYb");
function $76724d93b3883284$export$80c2a3957bcb42ea() {
    var isMounted = (0, $dvPqk.useRef)(false);
    (0, $05WYb.useIsomorphicLayoutEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});
parcelRegister("05WYb", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $129b6005e10e5eb6$export$700979bc83e7db82; });

var $dvPqk = parcelRequire("dvPqk");

var $92yhP = parcelRequire("92yhP");
var $129b6005e10e5eb6$export$700979bc83e7db82 = (0, $92yhP.isBrowser) ? (0, $dvPqk.useLayoutEffect) : (0, $dvPqk.useEffect);

});
parcelRegister("92yhP", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $dfc7c5e70d725005$export$4e09c449d6c407f7; });
var $dfc7c5e70d725005$export$4e09c449d6c407f7 = typeof document !== "undefined";

});




parcelRegister("jsGF3", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $e2f045d23f95e47e$export$979daf65881a382a; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $4CrdQ = parcelRequire("4CrdQ");

var $eCBBK = parcelRequire("eCBBK");

var $2gWXW = parcelRequire("2gWXW");
var $e2f045d23f95e47e$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $eCBBK.useConstant)($e2f045d23f95e47e$var$newChildrenMap);
    var id = (0, $2gWXW.useId)();
    var context = (0, $dvPqk.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                var e_1, _a;
                presenceChildren.set(childId, true);
                try {
                    for(var _b = (0, $ixrLi.__values)(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var isComplete = _c.value;
                        if (!isComplete) return; // can stop searching when any is incomplete
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                onExitComplete === null || onExitComplete === void 0 || onExitComplete();
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $dvPqk.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $dvPqk.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $dvPqk.createElement((0, $4CrdQ.PresenceContext).Provider, {
        value: context
    }, children);
};
function $e2f045d23f95e47e$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("4CrdQ", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $4231e649aa199f4c$export$f224e4635b6f8ce2; });

var $dvPqk = parcelRequire("dvPqk");
/**
 * @public
 */ var $4231e649aa199f4c$export$f224e4635b6f8ce2 = (0, $dvPqk.createContext)(null);

});

parcelRegister("eCBBK", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $654b408608b5ffdc$export$fe4300aa8eebea86; });

var $dvPqk = parcelRequire("dvPqk");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $654b408608b5ffdc$export$fe4300aa8eebea86(init) {
    var ref = (0, $dvPqk.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("2gWXW", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $836ef2ccaaa5fd30$export$f680877a34711e37; });

var $eCBBK = parcelRequire("eCBBK");
var $836ef2ccaaa5fd30$var$counter = 0;
var $836ef2ccaaa5fd30$var$incrementId = function() {
    return $836ef2ccaaa5fd30$var$counter++;
};
var $836ef2ccaaa5fd30$export$f680877a34711e37 = function() {
    return (0, $eCBBK.useConstant)($836ef2ccaaa5fd30$var$incrementId);
};

});


parcelRegister("5FwIO", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $2645bd1d2ad5d444$export$a3579ca508007a95; });

var $dvPqk = parcelRequire("dvPqk");
var $2645bd1d2ad5d444$export$a3579ca508007a95 = (0, $dvPqk.createContext)({});

});

parcelRegister("7lgsu", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $2670109f224bfb75$export$f3a192d0cbd30b96; });

var $dvPqk = parcelRequire("dvPqk");
function $2670109f224bfb75$export$f3a192d0cbd30b96(callback) {
    return (0, $dvPqk.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});


parcelRegister("bwNjW", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $9f14e545a5710a0c$export$e25e478948902b8b; });

var $ixrLi = parcelRequire("ixrLi");

var $1LnlO = parcelRequire("1LnlO");

var $e4D7p = parcelRequire("e4D7p");

var $jicvU = parcelRequire("jicvU");

var $4oC5U = parcelRequire("4oC5U");

var $iFhJr = parcelRequire("iFhJr");

var $6LR49 = parcelRequire("6LR49");

var $eKjSu = parcelRequire("eKjSu");

var $gELO0 = parcelRequire("gELO0");

var $jYUSn = parcelRequire("jYUSn");
var $9f14e545a5710a0c$var$featureBundle = (0, $ixrLi.__assign)((0, $ixrLi.__assign)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $iFhJr.animations)), (0, $4oC5U.gestureAnimations)), (0, $6LR49.drag)), (0, $gELO0.layoutFeatures));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $9f14e545a5710a0c$export$e25e478948902b8b = /*@__PURE__*/ (0, $e4D7p.createMotionProxy)(function(Component, config) {
    return (0, $jicvU.createDomMotionConfig)(Component, config, $9f14e545a5710a0c$var$featureBundle, (0, $eKjSu.createDomVisualElement), (0, $jYUSn.HTMLProjectionNode));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $9f14e545a5710a0c$export$546614c4a05701f9(key) {
    return (0, $1LnlO.createMotionComponent)((0, $jicvU.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $9f14e545a5710a0c$var$featureBundle, (0, $eKjSu.createDomVisualElement), (0, $jYUSn.HTMLProjectionNode)));
}

});
parcelRegister("1LnlO", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $32660598685315ed$export$46b7e4b9dc6110c3; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $3yTkU = parcelRequire("3yTkU");

var $9tqH6 = parcelRequire("9tqH6");

var $iXmGU = parcelRequire("iXmGU");

var $cIfA0 = parcelRequire("cIfA0");

var $9Fodc = parcelRequire("9Fodc");

var $6U6Ww = parcelRequire("6U6Ww");

var $80T5A = parcelRequire("80T5A");

var $92yhP = parcelRequire("92yhP");

var $hc6tB = parcelRequire("hc6tB");

var $5FwIO = parcelRequire("5FwIO");

var $fDrQq = parcelRequire("fDrQq");

var $a3aAd = parcelRequire("a3aAd");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $32660598685315ed$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $80T5A.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = $32660598685315ed$var$useLayoutId(props);
        props = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, $dvPqk.useContext)((0, $9tqH6.MotionConfigContext));
        var features = null;
        var context = (0, $6U6Ww.useCreateMotionContext)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = config.isStatic ? undefined : (0, $hc6tB.useProjectionId)();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $92yhP.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $cIfA0.useVisualElement)(Component, visualState, (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, config), props), createVisualElement);
            (0, $fDrQq.useProjection)(projectionId, props, context.visualElement, projectionNodeConstructor || (0, $80T5A.featureDefinitions).projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = (0, $3yTkU.useFeatures)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $dvPqk.createElement((0, $a3aAd.VisualElementHandler), {
            visualElement: context.visualElement,
            props: (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, config), props)
        }, features, $dvPqk.createElement((0, $iXmGU.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $9Fodc.useMotionRef)(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, $dvPqk.forwardRef)(MotionComponent);
}
function $32660598685315ed$var$useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, $dvPqk.useContext)((0, $5FwIO.LayoutGroupContext))) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("3yTkU", function(module, exports) {

$parcel$export(module.exports, "useFeatures", function () { return $64d7ec8d7f384146$export$4a39035bacc4ed76; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $hc7pA = parcelRequire("hc7pA");

var $80T5A = parcelRequire("80T5A");

var $8a1py = parcelRequire("8a1py");

var $kAnE1 = parcelRequire("kAnE1");
var $64d7ec8d7f384146$var$featureNames = Object.keys((0, $80T5A.featureDefinitions));
var $64d7ec8d7f384146$var$numFeatures = $64d7ec8d7f384146$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $64d7ec8d7f384146$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $dvPqk.useContext)((0, $kAnE1.LazyContext));
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if ((0, $hc7pA.env) !== "production" && preloadedFeatures && lazyContext.strict) (0, $8a1py.invariant)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(var i = 0; i < $64d7ec8d7f384146$var$numFeatures; i++){
        var name_1 = $64d7ec8d7f384146$var$featureNames[i];
        var _a = (0, $80T5A.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($dvPqk.createElement(Component, (0, $ixrLi.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}

});
parcelRegister("80T5A", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $d068bfd7e7ff698d$export$65570e08d843624d; });
$parcel$export(module.exports, "loadFeatures", function () { return $d068bfd7e7ff698d$export$449561ec5703cdc8; });
var $d068bfd7e7ff698d$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $d068bfd7e7ff698d$export$65570e08d843624d = {
    measureLayout: $d068bfd7e7ff698d$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $d068bfd7e7ff698d$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $d068bfd7e7ff698d$var$createDefinition([
        "exit"
    ]),
    drag: $d068bfd7e7ff698d$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $d068bfd7e7ff698d$var$createDefinition([
        "whileFocus"
    ]),
    hover: $d068bfd7e7ff698d$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $d068bfd7e7ff698d$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $d068bfd7e7ff698d$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $d068bfd7e7ff698d$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function $d068bfd7e7ff698d$export$449561ec5703cdc8(features) {
    for(var key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") $d068bfd7e7ff698d$export$65570e08d843624d.projectionNodeConstructor = features[key];
        else $d068bfd7e7ff698d$export$65570e08d843624d[key].Component = features[key];
    }
}

});

parcelRegister("8a1py", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $5f105a1f6d4e1596$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $5f105a1f6d4e1596$export$f5708dca728d7177; });
var $5f105a1f6d4e1596$export$491112666e282270 = function() {};
var $5f105a1f6d4e1596$export$f5708dca728d7177 = function() {};

});

parcelRegister("kAnE1", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $19bee43ec1fa9b96$export$40f10139ecf1f171; });

var $dvPqk = parcelRequire("dvPqk");
var $19bee43ec1fa9b96$export$40f10139ecf1f171 = (0, $dvPqk.createContext)({
    strict: false
});

});


parcelRegister("9tqH6", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $cce1a05b111743f1$export$22a697fb29aac98d; });

var $dvPqk = parcelRequire("dvPqk");
/**
 * @public
 */ var $cce1a05b111743f1$export$22a697fb29aac98d = (0, $dvPqk.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("iXmGU", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $f8981aea3b714746$export$2285bbca2c666415; });
$parcel$export(module.exports, "useVisualElementContext", function () { return $f8981aea3b714746$export$cd995842eb2ab956; });

var $dvPqk = parcelRequire("dvPqk");
var $f8981aea3b714746$export$2285bbca2c666415 = (0, $dvPqk.createContext)({});
function $f8981aea3b714746$export$cd995842eb2ab956() {
    return (0, $dvPqk.useContext)($f8981aea3b714746$export$2285bbca2c666415).visualElement;
}

});

parcelRegister("cIfA0", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $e57c7fbf77550315$export$dc0335d73ab0b115; });

var $dvPqk = parcelRequire("dvPqk");

var $4CrdQ = parcelRequire("4CrdQ");

var $iXmGU = parcelRequire("iXmGU");

var $05WYb = parcelRequire("05WYb");

var $kAnE1 = parcelRequire("kAnE1");

var $2dRcA = parcelRequire("2dRcA");
function $e57c7fbf77550315$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, $dvPqk.useContext)((0, $kAnE1.LazyContext));
    var parent = (0, $iXmGU.useVisualElementContext)();
    var presenceContext = (0, $dvPqk.useContext)((0, $4CrdQ.PresenceContext));
    var shouldReduceMotion = (0, $2dRcA.useReducedMotionConfig)();
    var visualElementRef = (0, $dvPqk.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    var visualElement = visualElementRef.current;
    (0, $05WYb.useIsomorphicLayoutEffect)(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $dvPqk.useEffect)(function() {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $05WYb.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRegister("2dRcA", function(module, exports) {

$parcel$export(module.exports, "useReducedMotionConfig", function () { return $203390c551ba11f2$export$ec21f7709af6bc1e; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $9tqH6 = parcelRequire("9tqH6");

var $92yhP = parcelRequire("92yhP");
// Does this device prefer reduced motion? Returns `null` server-side.
var $203390c551ba11f2$var$prefersReducedMotion = {
    current: null
};
var $203390c551ba11f2$var$hasDetected = false;
function $203390c551ba11f2$var$initPrefersReducedMotion() {
    $203390c551ba11f2$var$hasDetected = true;
    if (!(0, $92yhP.isBrowser)) return;
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return $203390c551ba11f2$var$prefersReducedMotion.current = motionMediaQuery_1.matches;
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else $203390c551ba11f2$var$prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $203390c551ba11f2$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !$203390c551ba11f2$var$hasDetected && $203390c551ba11f2$var$initPrefersReducedMotion();
    var _a = (0, $ixrLi.__read)((0, $dvPqk.useState)($203390c551ba11f2$var$prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function $203390c551ba11f2$export$ec21f7709af6bc1e() {
    var reducedMotionPreference = $203390c551ba11f2$export$6a42007cf1e7b6f8();
    var reducedMotion = (0, $dvPqk.useContext)((0, $9tqH6.MotionConfigContext)).reducedMotion;
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}

});


parcelRegister("9Fodc", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $7bae59702a23873b$export$c684914703d321fd; });

var $dvPqk = parcelRequire("dvPqk");

var $do7qJ = parcelRequire("do7qJ");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $7bae59702a23873b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $dvPqk.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $do7qJ.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("do7qJ", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $260bb27f9a246f4c$export$dedd81df7bc1307; });
function $260bb27f9a246f4c$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("6U6Ww", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $ddb5d7d5a5113495$export$c5638d843b37a176; });

var $dvPqk = parcelRequire("dvPqk");

var $iXmGU = parcelRequire("iXmGU");

var $iulmd = parcelRequire("iulmd");
function $ddb5d7d5a5113495$export$c5638d843b37a176(props) {
    var _a = (0, $iulmd.getCurrentTreeVariants)(props, (0, $dvPqk.useContext)((0, $iXmGU.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $dvPqk.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $ddb5d7d5a5113495$var$variantLabelsAsDependency(initial),
        $ddb5d7d5a5113495$var$variantLabelsAsDependency(animate)
    ]);
}
function $ddb5d7d5a5113495$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("iulmd", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $e668164bcc4b1678$export$12fc32fc096a04a3; });

var $2qIDj = parcelRequire("2qIDj");
function $e668164bcc4b1678$export$12fc32fc096a04a3(props, context) {
    if ((0, $2qIDj.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $2qIDj.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $2qIDj.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("2qIDj", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", function () { return $e92d33b8088628f0$export$562271cd22f751d; });
$parcel$export(module.exports, "isVariantLabel", function () { return $e92d33b8088628f0$export$720b90e312cea233; });
$parcel$export(module.exports, "resolveVariantFromProps", function () { return $e92d33b8088628f0$export$d68f140c4d9b48bc; });
$parcel$export(module.exports, "resolveVariant", function () { return $e92d33b8088628f0$export$7b1b1c981f4f0558; });
$parcel$export(module.exports, "checkIfControllingVariants", function () { return $e92d33b8088628f0$export$cf3a7bd331c35bf0; });
$parcel$export(module.exports, "checkIfVariantNode", function () { return $e92d33b8088628f0$export$c0eba02279c18fea; });
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $e92d33b8088628f0$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $e92d33b8088628f0$export$720b90e312cea233(v) {
    return typeof v === "string" || $e92d33b8088628f0$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $e92d33b8088628f0$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $e92d33b8088628f0$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $e92d33b8088628f0$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function $e92d33b8088628f0$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $e92d33b8088628f0$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $e92d33b8088628f0$var$getCurrent(visualElement), $e92d33b8088628f0$var$getVelocity(visualElement));
}
function $e92d33b8088628f0$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $e92d33b8088628f0$export$720b90e312cea233(props.initial) || $e92d33b8088628f0$export$720b90e312cea233(props.animate) || $e92d33b8088628f0$export$720b90e312cea233(props.whileHover) || $e92d33b8088628f0$export$720b90e312cea233(props.whileDrag) || $e92d33b8088628f0$export$720b90e312cea233(props.whileTap) || $e92d33b8088628f0$export$720b90e312cea233(props.whileFocus) || $e92d33b8088628f0$export$720b90e312cea233(props.exit);
}
function $e92d33b8088628f0$export$c0eba02279c18fea(props) {
    return Boolean($e92d33b8088628f0$export$cf3a7bd331c35bf0(props) || props.variants);
}

});



parcelRegister("hc6tB", function(module, exports) {

$parcel$export(module.exports, "useProjectionId", function () { return $f0c57e5e0bee3a10$export$5ed57b87c18af11a; });

var $eCBBK = parcelRequire("eCBBK");

var $c1xBr = parcelRequire("c1xBr");
var $f0c57e5e0bee3a10$var$id = 1;
function $f0c57e5e0bee3a10$export$5ed57b87c18af11a() {
    return (0, $eCBBK.useConstant)(function() {
        if ((0, $c1xBr.globalProjectionState).hasEverUpdated) return $f0c57e5e0bee3a10$var$id++;
    });
}

});
parcelRegister("c1xBr", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $5806cecfddce3171$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $5806cecfddce3171$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});


parcelRegister("fDrQq", function(module, exports) {

$parcel$export(module.exports, "useProjection", function () { return $e4fc25724e9e2e06$export$80ade90e64f5118b; });

var $do7qJ = parcelRequire("do7qJ");

var $dvPqk = parcelRequire("dvPqk");

var $bJXtv = parcelRequire("bJXtv");
function $e4fc25724e9e2e06$export$80ade90e64f5118b(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = (0, $dvPqk.useContext)((0, $bJXtv.SwitchLayoutGroupContext));
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $do7qJ.isRefObject)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}

});
parcelRegister("bJXtv", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $7a43cd7dc6884f9c$export$da5f7b802957459a; });

var $dvPqk = parcelRequire("dvPqk");
/**
 * Internal, exported only for usage in Framer
 */ var $7a43cd7dc6884f9c$export$da5f7b802957459a = (0, $dvPqk.createContext)({});

});


parcelRegister("a3aAd", function(module, exports) {

$parcel$export(module.exports, "VisualElementHandler", function () { return $dc095b738e18042b$export$a9ca437df31f9491; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");
var $dc095b738e18042b$export$a9ca437df31f9491 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Component);

});


parcelRegister("e4D7p", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $d4602133aac72786$export$a28d6df673050e18; });

var $1LnlO = parcelRequire("1LnlO");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $d4602133aac72786$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $1LnlO.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("jicvU", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $56ecabac9a60d946$export$732916c0e88175fb; });

var $ixrLi = parcelRequire("ixrLi");

var $8uGvj = parcelRequire("8uGvj");

var $7ME5d = parcelRequire("7ME5d");

var $QlR9g = parcelRequire("QlR9g");

var $5JnIN = parcelRequire("5JnIN");
function $56ecabac9a60d946$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $8uGvj.isSVGComponent)(Component) ? (0, $QlR9g.svgMotionConfig) : (0, $5JnIN.htmlMotionConfig);
    return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $7ME5d.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}

});
parcelRegister("8uGvj", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $a112d9b2996e8362$export$88f3fc2fd3766989; });

var $bVFf1 = parcelRequire("bVFf1");
function $a112d9b2996e8362$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $bVFf1.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("bVFf1", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $b87462cc7412eb01$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $b87462cc7412eb01$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("7ME5d", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $f4c1f46b1e483ddb$export$5d29104eefd89cc8; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $eHxoj = parcelRequire("eHxoj");

var $bH6SC = parcelRequire("bH6SC");

var $8uGvj = parcelRequire("8uGvj");

var $9jump = parcelRequire("9jump");
function $f4c1f46b1e483ddb$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $8uGvj.isSVGComponent)(Component) ? (0, $9jump.useSVGProps) : (0, $eHxoj.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $bH6SC.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $ixrLi.__assign)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $dvPqk.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRegister("eHxoj", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $12c9293502759e6f$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $12c9293502759e6f$export$57be0a314572d87d; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $cdCU3 = parcelRequire("cdCU3");

var $jVe7Z = parcelRequire("jVe7Z");

var $7Oa8X = parcelRequire("7Oa8X");

var $7J4b1 = parcelRequire("7J4b1");
function $12c9293502759e6f$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $jVe7Z.isMotionValue)(source[key]) && !(0, $cdCU3.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $12c9293502759e6f$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $dvPqk.useMemo)(function() {
        var state = (0, $7J4b1.createHtmlRenderState)();
        (0, $7Oa8X.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $12c9293502759e6f$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $12c9293502759e6f$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $12c9293502759e6f$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $12c9293502759e6f$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $12c9293502759e6f$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("cdCU3", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $f26d911e69eb7083$export$6d27ce8e3de1c3cf; });

var $HsryT = parcelRequire("HsryT");

var $hnWph = parcelRequire("hnWph");
function $f26d911e69eb7083$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $hnWph.isTransformProp)(key) || (0, $hnWph.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $HsryT.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("HsryT", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $d713bbea08a7eef1$export$91ddd985b97788d1; });
$parcel$export(module.exports, "addScaleCorrector", function () { return $d713bbea08a7eef1$export$de9e7791c71225fd; });
var $d713bbea08a7eef1$export$91ddd985b97788d1 = {};
function $d713bbea08a7eef1$export$de9e7791c71225fd(correctors) {
    Object.assign($d713bbea08a7eef1$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("hnWph", function(module, exports) {

$parcel$export(module.exports, "transformAxes", function () { return $8e5ccee251c1d5a3$export$67cd428da31419e1; });
$parcel$export(module.exports, "transformProps", function () { return $8e5ccee251c1d5a3$export$7b42a0094fb00b6e; });
$parcel$export(module.exports, "sortTransformProps", function () { return $8e5ccee251c1d5a3$export$61f68472e7973485; });
$parcel$export(module.exports, "isTransformProp", function () { return $8e5ccee251c1d5a3$export$15240a8a4379d8de; });
$parcel$export(module.exports, "isTransformOriginProp", function () { return $8e5ccee251c1d5a3$export$91fe49ee9d172523; });
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $8e5ccee251c1d5a3$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $8e5ccee251c1d5a3$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $8e5ccee251c1d5a3$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$8e5ccee251c1d5a3$var$order.forEach(function(operationKey) {
    return $8e5ccee251c1d5a3$export$67cd428da31419e1.forEach(function(axesKey) {
        return $8e5ccee251c1d5a3$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $8e5ccee251c1d5a3$export$61f68472e7973485(a, b) {
    return $8e5ccee251c1d5a3$export$7b42a0094fb00b6e.indexOf(a) - $8e5ccee251c1d5a3$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $8e5ccee251c1d5a3$var$transformPropSet = new Set($8e5ccee251c1d5a3$export$7b42a0094fb00b6e);
function $8e5ccee251c1d5a3$export$15240a8a4379d8de(key) {
    return $8e5ccee251c1d5a3$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $8e5ccee251c1d5a3$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $8e5ccee251c1d5a3$export$91fe49ee9d172523(key) {
    return $8e5ccee251c1d5a3$var$transformOriginProps.has(key);
}

});


parcelRegister("jVe7Z", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $1f28950098c26503$export$605d60a2578142d3; });
var $1f28950098c26503$export$605d60a2578142d3 = function(value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};

});

parcelRegister("7Oa8X", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $b7b8653652df1ae8$export$bb517f8b40f8e99d; });

var $3ae8W = parcelRequire("3ae8W");

var $99KN0 = parcelRequire("99KN0");

var $hnWph = parcelRequire("hnWph");

var $60KHI = parcelRequire("60KHI");

var $VgrW1 = parcelRequire("VgrW1");
function $b7b8653652df1ae8$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $99KN0.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $VgrW1.numberValueTypes)[key];
        var valueAsType = (0, $60KHI.getValueAsType)(value, valueType);
        if ((0, $hnWph.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $hnWph.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $3ae8W.buildTransform)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = (0, $3ae8W.buildTransformOrigin)(transformOrigin);
}

});
parcelRegister("3ae8W", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $7af45087f3ef7729$export$bdc96e0d5c8f914; });
$parcel$export(module.exports, "buildTransformOrigin", function () { return $7af45087f3ef7729$export$22d2fbf39767d07a; });

var $hnWph = parcelRequire("hnWph");
var $7af45087f3ef7729$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $7af45087f3ef7729$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $hnWph.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += "".concat($7af45087f3ef7729$var$translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $7af45087f3ef7729$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}

});

parcelRegister("99KN0", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", function () { return $20cb92727f150d62$export$451bc42768436155; });
/**
 * Returns true if the provided key is a CSS variable
 */ function $20cb92727f150d62$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRegister("60KHI", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $58f63f1f99ecb014$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $58f63f1f99ecb014$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("VgrW1", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $77ef81de6ac4440d$export$eec14432cd1cb67b; });

var $h5uhF = parcelRequire("h5uhF");
var $hJuU3 = parcelRequire("hJuU3");

var $jBuvN = parcelRequire("jBuvN");
var $77ef81de6ac4440d$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $hJuU3.px),
    borderTopWidth: (0, $hJuU3.px),
    borderRightWidth: (0, $hJuU3.px),
    borderBottomWidth: (0, $hJuU3.px),
    borderLeftWidth: (0, $hJuU3.px),
    borderRadius: (0, $hJuU3.px),
    radius: (0, $hJuU3.px),
    borderTopLeftRadius: (0, $hJuU3.px),
    borderTopRightRadius: (0, $hJuU3.px),
    borderBottomRightRadius: (0, $hJuU3.px),
    borderBottomLeftRadius: (0, $hJuU3.px),
    // Positioning props
    width: (0, $hJuU3.px),
    maxWidth: (0, $hJuU3.px),
    height: (0, $hJuU3.px),
    maxHeight: (0, $hJuU3.px),
    size: (0, $hJuU3.px),
    top: (0, $hJuU3.px),
    right: (0, $hJuU3.px),
    bottom: (0, $hJuU3.px),
    left: (0, $hJuU3.px),
    // Spacing props
    padding: (0, $hJuU3.px),
    paddingTop: (0, $hJuU3.px),
    paddingRight: (0, $hJuU3.px),
    paddingBottom: (0, $hJuU3.px),
    paddingLeft: (0, $hJuU3.px),
    margin: (0, $hJuU3.px),
    marginTop: (0, $hJuU3.px),
    marginRight: (0, $hJuU3.px),
    marginBottom: (0, $hJuU3.px),
    marginLeft: (0, $hJuU3.px),
    // Transform props
    rotate: (0, $hJuU3.degrees),
    rotateX: (0, $hJuU3.degrees),
    rotateY: (0, $hJuU3.degrees),
    rotateZ: (0, $hJuU3.degrees),
    scale: (0, $h5uhF.scale),
    scaleX: (0, $h5uhF.scale),
    scaleY: (0, $h5uhF.scale),
    scaleZ: (0, $h5uhF.scale),
    skew: (0, $hJuU3.degrees),
    skewX: (0, $hJuU3.degrees),
    skewY: (0, $hJuU3.degrees),
    distance: (0, $hJuU3.px),
    translateX: (0, $hJuU3.px),
    translateY: (0, $hJuU3.px),
    translateZ: (0, $hJuU3.px),
    x: (0, $hJuU3.px),
    y: (0, $hJuU3.px),
    z: (0, $hJuU3.px),
    perspective: (0, $hJuU3.px),
    transformPerspective: (0, $hJuU3.px),
    opacity: (0, $h5uhF.alpha),
    originX: (0, $hJuU3.progressPercentage),
    originY: (0, $hJuU3.progressPercentage),
    originZ: (0, $hJuU3.px),
    // Misc
    zIndex: (0, $jBuvN.int),
    // SVG
    fillOpacity: (0, $h5uhF.alpha),
    strokeOpacity: (0, $h5uhF.alpha),
    numOctaves: (0, $jBuvN.int)
};

});
parcelRegister("h5uhF", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $3a67d7315eeafc28$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $3a67d7315eeafc28$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $3a67d7315eeafc28$export$dcdf75081b88279d; });

var $fGmj9 = parcelRequire("fGmj9");
const $3a67d7315eeafc28$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3a67d7315eeafc28$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $3a67d7315eeafc28$export$98e628dec113755e), {
    transform: (0, $fGmj9.clamp)(0, 1)
});
const $3a67d7315eeafc28$export$dcdf75081b88279d = Object.assign(Object.assign({}, $3a67d7315eeafc28$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("fGmj9", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $2084d3035a6a49f2$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "sanitize", function () { return $2084d3035a6a49f2$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $2084d3035a6a49f2$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $2084d3035a6a49f2$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $2084d3035a6a49f2$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $2084d3035a6a49f2$export$844ec244b1367d54; });
const $2084d3035a6a49f2$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $2084d3035a6a49f2$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $2084d3035a6a49f2$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $2084d3035a6a49f2$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const $2084d3035a6a49f2$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $2084d3035a6a49f2$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRegister("hJuU3", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $7d49416188c96c41$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $7d49416188c96c41$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $7d49416188c96c41$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $7d49416188c96c41$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $7d49416188c96c41$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $7d49416188c96c41$export$44e2e1705876d7ed; });

var $fGmj9 = parcelRequire("fGmj9");
const $7d49416188c96c41$var$createUnitType = (unit)=>({
        test: (v)=>(0, $fGmj9.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $7d49416188c96c41$export$41fc368e1a942b97 = $7d49416188c96c41$var$createUnitType("deg");
const $7d49416188c96c41$export$626336c2cd4b14de = $7d49416188c96c41$var$createUnitType("%");
const $7d49416188c96c41$export$91c0eda1d06bf008 = $7d49416188c96c41$var$createUnitType("px");
const $7d49416188c96c41$export$f91e8c45a95a32f2 = $7d49416188c96c41$var$createUnitType("vh");
const $7d49416188c96c41$export$aed3d7b7d206c196 = $7d49416188c96c41$var$createUnitType("vw");
const $7d49416188c96c41$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $7d49416188c96c41$export$626336c2cd4b14de), {
    parse: (v)=>$7d49416188c96c41$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$7d49416188c96c41$export$626336c2cd4b14de.transform(v * 100)
});

});

parcelRegister("jBuvN", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $60ea7399dfde5f68$export$7d260a2a5f8bc19e; });

var $ixrLi = parcelRequire("ixrLi");

var $h5uhF = parcelRequire("h5uhF");
var $60ea7399dfde5f68$export$7d260a2a5f8bc19e = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $h5uhF.number)), {
    transform: Math.round
});

});



parcelRegister("7J4b1", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $1474e33a9b505a10$export$8940b483cf52eeda; });
var $1474e33a9b505a10$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("bH6SC", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $ed21a7eedbbf5baf$export$d697c39a2985a4c; });

var $i3QDg = parcelRequire("i3QDg");
var $ed21a7eedbbf5baf$var$shouldForward = function(key) {
    return !(0, $i3QDg.isValidMotionProp)(key);
};
function $ed21a7eedbbf5baf$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $ed21a7eedbbf5baf$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $i3QDg.isValidMotionProp)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $ed21a7eedbbf5baf$export$59d6962c470509a5((parcelRequire("aU6IB")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $ed21a7eedbbf5baf$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($ed21a7eedbbf5baf$var$shouldForward(key) || forwardMotionProps === true && (0, $i3QDg.isValidMotionProp)(key) || !isDom && !(0, $i3QDg.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRegister("i3QDg", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $c9766a3ced6b4b46$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $c9766a3ced6b4b46$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c9766a3ced6b4b46$export$2f9c46555243bf04(key) {
    return $c9766a3ced6b4b46$var$validMotionProps.has(key);
}

});

parcelRegister("aU6IB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f045879201a226a$export$2e2bcd8739ae039; });

var $hyLeO = parcelRequire("hyLeO");
var $7f045879201a226a$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $7f045879201a226a$var$index = (0, $hyLeO.default)(function(prop) {
    return $7f045879201a226a$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $7f045879201a226a$export$2e2bcd8739ae039 = $7f045879201a226a$var$index;

});
parcelRegister("hyLeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc8a411bff600a6f$export$2e2bcd8739ae039; });
function $cc8a411bff600a6f$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $cc8a411bff600a6f$export$2e2bcd8739ae039 = $cc8a411bff600a6f$var$memoize;

});



parcelRegister("9jump", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $d68118750f32cd35$export$84309c4f53cb1bd5; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $eHxoj = parcelRequire("eHxoj");

var $DipmX = parcelRequire("DipmX");

var $gSdw9 = parcelRequire("gSdw9");
function $d68118750f32cd35$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $dvPqk.useMemo)(function() {
        var state = (0, $gSdw9.createSvgRenderState)();
        (0, $DipmX.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, state.attrs), {
            style: (0, $ixrLi.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $eHxoj.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("DipmX", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $da84f25b376666f7$export$5475d24f125d7053; });

var $ixrLi = parcelRequire("ixrLi");

var $7Oa8X = parcelRequire("7Oa8X");

var $5vxZi = parcelRequire("5vxZi");

var $KF9pm = parcelRequire("KF9pm");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $da84f25b376666f7$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $ixrLi.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $7Oa8X.buildHTMLStyles)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $5vxZi.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $KF9pm.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("5vxZi", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $2afa62785aba6b5f$export$d4fbcfc8e5472155; });

var $hJuU3 = parcelRequire("hJuU3");
function $2afa62785aba6b5f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $hJuU3.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2afa62785aba6b5f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $2afa62785aba6b5f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $2afa62785aba6b5f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}

});

parcelRegister("KF9pm", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $b285c31940114242$export$311b43f666da1d82; });

var $hJuU3 = parcelRequire("hJuU3");
var $b285c31940114242$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $b285c31940114242$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $b285c31940114242$export$311b43f666da1d82(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $b285c31940114242$var$dashKeys : $b285c31940114242$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $hJuU3.px).transform(-offset);
    // Build the dash array
    var pathLength = (0, $hJuU3.px).transform(length);
    var pathSpacing = (0, $hJuU3.px).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

});


parcelRegister("gSdw9", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $45de01a4ff7571a8$export$41be8b43e1c4d4f9; });

var $ixrLi = parcelRequire("ixrLi");

var $7J4b1 = parcelRequire("7J4b1");
var $45de01a4ff7571a8$export$41be8b43e1c4d4f9 = function() {
    return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $7J4b1.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRegister("QlR9g", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $8faa13883439772e$export$44dabd3fae512e85; });

var $12TDz = parcelRequire("12TDz");

var $gRbv0 = parcelRequire("gRbv0");

var $8Ykkw = parcelRequire("8Ykkw");

var $gSdw9 = parcelRequire("gSdw9");

var $DipmX = parcelRequire("DipmX");
var $8faa13883439772e$export$44dabd3fae512e85 = {
    useVisualState: (0, $8Ykkw.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $gRbv0.scrapeMotionValuesFromProps),
        createRenderState: (0, $gSdw9.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $DipmX.buildSVGAttrs)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            (0, $12TDz.renderSVG)(instance, renderState);
        }
    })
};

});
parcelRegister("12TDz", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $d12d0da3f17b21ae$export$c5f8399d19a7394b; });

var $58YXb = parcelRequire("58YXb");

var $85Lqx = parcelRequire("85Lqx");

var $6bg86 = parcelRequire("6bg86");
function $d12d0da3f17b21ae$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $85Lqx.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $6bg86.camelCaseAttributes).has(key) ? (0, $58YXb.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("58YXb", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $330e9c02705bdb1e$export$9fd24a634729c672; });
var $330e9c02705bdb1e$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $330e9c02705bdb1e$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $330e9c02705bdb1e$export$9fd24a634729c672 = function(str) {
    return str.replace($330e9c02705bdb1e$var$CAMEL_CASE_PATTERN, $330e9c02705bdb1e$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRegister("85Lqx", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $06e78cfb4d584505$export$1a32bf6229c258c0; });
function $06e78cfb4d584505$export$1a32bf6229c258c0(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("6bg86", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $caffca3c719154a7$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $caffca3c719154a7$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);

});


parcelRegister("gRbv0", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $05f794cb4152fc0d$export$16da615486abaa45; });

var $jVe7Z = parcelRequire("jVe7Z");

var $hsvVs = parcelRequire("hsvVs");
function $05f794cb4152fc0d$export$16da615486abaa45(props) {
    var newValues = (0, $hsvVs.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $jVe7Z.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("hsvVs", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $4d20fefc4ec0f264$export$16da615486abaa45; });

var $cdCU3 = parcelRequire("cdCU3");

var $jVe7Z = parcelRequire("jVe7Z");
function $4d20fefc4ec0f264$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $jVe7Z.isMotionValue)(style[key]) || (0, $cdCU3.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("8Ykkw", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $16a3a9b2efb8afdd$export$e91e107bc6d03a8e; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $3gQWn = parcelRequire("3gQWn");

var $4CrdQ = parcelRequire("4CrdQ");

var $2qIDj = parcelRequire("2qIDj");

var $eCBBK = parcelRequire("eCBBK");

var $41Ktj = parcelRequire("41Ktj");

var $iXmGU = parcelRequire("iXmGU");
function $16a3a9b2efb8afdd$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $16a3a9b2efb8afdd$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $16a3a9b2efb8afdd$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $dvPqk.useContext)((0, $iXmGU.MotionContext));
        var presenceContext = (0, $dvPqk.useContext)((0, $4CrdQ.PresenceContext));
        return isStatic ? $16a3a9b2efb8afdd$var$makeState(config, props, context, presenceContext) : (0, $eCBBK.useConstant)(function() {
            return $16a3a9b2efb8afdd$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $16a3a9b2efb8afdd$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $41Ktj.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $2qIDj.checkIfControllingVariants)(props);
    var isVariantNode = (0, $2qIDj.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $3gQWn.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $2qIDj.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $ixrLi.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target){
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("3gQWn", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $37b5559bc4a830c3$export$aa71198ceeaf53ce; });
function $37b5559bc4a830c3$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("41Ktj", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $96a60784617ac0ae$export$fcc2206ecb6d74b; });

var $jmrkB = parcelRequire("jmrkB");

var $jVe7Z = parcelRequire("jVe7Z");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $96a60784617ac0ae$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $jVe7Z.isMotionValue)(value) ? value.get() : value;
    return (0, $jmrkB.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("jmrkB", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $3d8fad3f38a01513$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $3d8fad3f38a01513$export$5485128c47bd48bb; });

var $1aE8G = parcelRequire("1aE8G");
var $3d8fad3f38a01513$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $3d8fad3f38a01513$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $1aE8G.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("1aE8G", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $512479776d343a07$export$9153ad4c4999f4a0; });
var $512479776d343a07$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});





parcelRegister("5JnIN", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $92ea3cddb89ec441$export$e13ea21d87ea57c8; });

var $8Ykkw = parcelRequire("8Ykkw");

var $hsvVs = parcelRequire("hsvVs");

var $7J4b1 = parcelRequire("7J4b1");
var $92ea3cddb89ec441$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $8Ykkw.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $hsvVs.scrapeMotionValuesFromProps),
        createRenderState: (0, $7J4b1.createHtmlRenderState)
    })
};

});


parcelRegister("4oC5U", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $2ce428032befd4a8$export$e5b72898e5a201f1; });

var $1yem9 = parcelRequire("1yem9");

var $3JXgD = parcelRequire("3JXgD");

var $ePV1o = parcelRequire("ePV1o");

var $2GIu3 = parcelRequire("2GIu3");

var $5qyn5 = parcelRequire("5qyn5");
var $2ce428032befd4a8$export$e5b72898e5a201f1 = {
    inView: (0, $5qyn5.makeRenderlessComponent)((0, $2GIu3.useViewport)),
    tap: (0, $5qyn5.makeRenderlessComponent)((0, $ePV1o.useTapGesture)),
    focus: (0, $5qyn5.makeRenderlessComponent)((0, $1yem9.useFocusGesture)),
    hover: (0, $5qyn5.makeRenderlessComponent)((0, $3JXgD.useHoverGesture))
};

});
parcelRegister("1yem9", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", function () { return $1d98e7b394395ddd$export$cac52d7cca250a66; });

var $jQ0wz = parcelRequire("jQ0wz");

var $imjsK = parcelRequire("imjsK");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $1d98e7b394395ddd$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Focus, false);
    };
    (0, $imjsK.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $imjsK.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});
parcelRegister("jQ0wz", function(module, exports) {

$parcel$export(module.exports, "AnimationType", function () { return $c78e781f190210ee$export$2deb71ebd3734d23; });
var $c78e781f190210ee$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($c78e781f190210ee$export$2deb71ebd3734d23 || ($c78e781f190210ee$export$2deb71ebd3734d23 = {}));

});

parcelRegister("imjsK", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $cc0a649aea2f3ab5$export$b1d829ddf82884aa; });
$parcel$export(module.exports, "useDomEvent", function () { return $cc0a649aea2f3ab5$export$c1052189363cb2e0; });

var $dvPqk = parcelRequire("dvPqk");
function $cc0a649aea2f3ab5$export$b1d829ddf82884aa(target, eventName, handler, options) {
    if (options === void 0) options = {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $cc0a649aea2f3ab5$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $dvPqk.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $cc0a649aea2f3ab5$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});


parcelRegister("3JXgD", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", function () { return $e240975498fcee2b$export$dea06860711b7ebc; });

var $eFGHg = parcelRequire("eFGHg");

var $jQ0wz = parcelRequire("jQ0wz");

var $rMFdN = parcelRequire("rMFdN");

var $jSwNR = parcelRequire("jSwNR");
function $e240975498fcee2b$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $eFGHg.isMouseEvent)(event) || (0, $jSwNR.isDragActive)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function $e240975498fcee2b$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $rMFdN.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $e240975498fcee2b$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $rMFdN.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $e240975498fcee2b$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}

});
parcelRegister("eFGHg", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", function () { return $ce5014860b09855d$export$764db16956f554f8; });
$parcel$export(module.exports, "isTouchEvent", function () { return $ce5014860b09855d$export$c4dfce035d43d1e0; });
function $ce5014860b09855d$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $ce5014860b09855d$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRegister("rMFdN", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $677cc2fe75c93cb4$export$fcff2e64e6676b81; });
$parcel$export(module.exports, "usePointerEvent", function () { return $677cc2fe75c93cb4$export$734d04395f5243cd; });

var $imjsK = parcelRequire("imjsK");

var $boIG2 = parcelRequire("boIG2");

var $1BMST = parcelRequire("1BMST");
var $677cc2fe75c93cb4$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $677cc2fe75c93cb4$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $677cc2fe75c93cb4$var$getPointerEventName(name) {
    if ((0, $1BMST.supportsPointerEvents)()) return name;
    else if ((0, $1BMST.supportsTouchEvents)()) return $677cc2fe75c93cb4$var$touchEventNames[name];
    else if ((0, $1BMST.supportsMouseEvents)()) return $677cc2fe75c93cb4$var$mouseEventNames[name];
    return name;
}
function $677cc2fe75c93cb4$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $imjsK.addDomEvent)(target, $677cc2fe75c93cb4$var$getPointerEventName(eventName), (0, $boIG2.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $677cc2fe75c93cb4$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $imjsK.useDomEvent)(ref, $677cc2fe75c93cb4$var$getPointerEventName(eventName), handler && (0, $boIG2.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRegister("boIG2", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $3e0387c962fe7d22$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "wrapHandler", function () { return $3e0387c962fe7d22$export$f4437ba81469b709; });

var $eFGHg = parcelRequire("eFGHg");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $3e0387c962fe7d22$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $3e0387c962fe7d22$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $3e0387c962fe7d22$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $3e0387c962fe7d22$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $3e0387c962fe7d22$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $3e0387c962fe7d22$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $eFGHg.isTouchEvent)(event) ? $3e0387c962fe7d22$var$pointFromTouch(event, pointType) : $3e0387c962fe7d22$var$pointFromMouse(event, pointType)
    };
}
var $3e0387c962fe7d22$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $3e0387c962fe7d22$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $3e0387c962fe7d22$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRegister("1BMST", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", function () { return $6423543cafcbe598$export$ed662207763ba653; });
$parcel$export(module.exports, "supportsTouchEvents", function () { return $6423543cafcbe598$export$58e9cbc5718eb8c2; });
$parcel$export(module.exports, "supportsMouseEvents", function () { return $6423543cafcbe598$export$1a3879af679d3ede; });

var $92yhP = parcelRequire("92yhP");
// We check for event support via functions in case they've been mocked by a testing suite.
var $6423543cafcbe598$export$ed662207763ba653 = function() {
    return (0, $92yhP.isBrowser) && window.onpointerdown === null;
};
var $6423543cafcbe598$export$58e9cbc5718eb8c2 = function() {
    return (0, $92yhP.isBrowser) && window.ontouchstart === null;
};
var $6423543cafcbe598$export$1a3879af679d3ede = function() {
    return (0, $92yhP.isBrowser) && window.onmousedown === null;
};

});


parcelRegister("jSwNR", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $7c59564a149fd3ec$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $7c59564a149fd3ec$export$1b3dd616664938e4; });
function $7c59564a149fd3ec$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $7c59564a149fd3ec$var$globalHorizontalLock = $7c59564a149fd3ec$export$518c5fc2dcb7974b("dragHorizontal");
var $7c59564a149fd3ec$var$globalVerticalLock = $7c59564a149fd3ec$export$518c5fc2dcb7974b("dragVertical");
function $7c59564a149fd3ec$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $7c59564a149fd3ec$var$globalVerticalLock();
    else if (drag === "x") lock = $7c59564a149fd3ec$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $7c59564a149fd3ec$var$globalHorizontalLock();
        var openVertical_1 = $7c59564a149fd3ec$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $7c59564a149fd3ec$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $7c59564a149fd3ec$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("ePV1o", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", function () { return $415944ebe54a4ac9$export$16dee6ef8c34532; });

var $dvPqk = parcelRequire("dvPqk");

var $a1YHV = parcelRequire("a1YHV");

var $rMFdN = parcelRequire("rMFdN");

var $7lgsu = parcelRequire("7lgsu");

var $aLmIo = parcelRequire("aLmIo");

var $jQ0wz = parcelRequire("jQ0wz");

var $jSwNR = parcelRequire("jSwNR");
/**
 * @param handlers -
 * @internal
 */ function $415944ebe54a4ac9$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $dvPqk.useRef)(false);
    var cancelPointerEndListeners = (0, $dvPqk.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ var eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Tap, false);
        return !(0, $jSwNR.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $a1YHV.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $aLmIo.pipe)((0, $rMFdN.addPointerEvent)(window, "pointerup", onPointerUp, eventOptions), (0, $rMFdN.addPointerEvent)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    (0, $rMFdN.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $7lgsu.useUnmountEffect)(removePointerEndListener);
}

});
parcelRegister("a1YHV", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $8b9244a3c7832fac$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $8b9244a3c7832fac$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $8b9244a3c7832fac$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("aLmIo", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $5391acbe78dd6ade$export$a4627e546088548d; });
const $5391acbe78dd6ade$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $5391acbe78dd6ade$export$a4627e546088548d = (...transformers)=>transformers.reduce($5391acbe78dd6ade$var$combineFunctions);

});


parcelRegister("2GIu3", function(module, exports) {

$parcel$export(module.exports, "useViewport", function () { return $7e98f24850748053$export$297ec8eb77d6211d; });

var $hc7pA = parcelRequire("hc7pA");

var $dvPqk = parcelRequire("dvPqk");

var $jQ0wz = parcelRequire("jQ0wz");

var $k7bSp = parcelRequire("k7bSp");

var $4NRCw = parcelRequire("4NRCw");
function $7e98f24850748053$export$297ec8eb77d6211d(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = (0, $dvPqk.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined" ? $7e98f24850748053$var$useMissingIntersectionObserver : $7e98f24850748053$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var $7e98f24850748053$var$thresholdNames = {
    some: 0,
    all: 1
};
function $7e98f24850748053$var$useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    (0, $dvPqk.useEffect)(function() {
        if (!shouldObserve) return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $7e98f24850748053$var$thresholdNames[amount]
        };
        var intersectionCallback = function(entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var props = visualElement.getProps();
            var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return (0, $4NRCw.observeIntersection)(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $7e98f24850748053$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
    (0, $dvPqk.useEffect)(function() {
        if (!shouldObserve || !fallback) return;
        if ((0, $hc7pA.env) !== "production") (0, $k7bSp.warnOnce)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(function() {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).InView, true);
        });
    }, [
        shouldObserve
    ]);
}

});
parcelRegister("k7bSp", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $96063ac7ac5f50d2$export$5b28268982f175ba; });
var $96063ac7ac5f50d2$var$warned = new Set();
function $96063ac7ac5f50d2$export$5b28268982f175ba(condition, message, element) {
    if (condition || $96063ac7ac5f50d2$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $96063ac7ac5f50d2$var$warned.add(message);
}

});

parcelRegister("4NRCw", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $874d26650225b9e6$export$b2bcd62fb7925aa5; });

var $ixrLi = parcelRequire("ixrLi");
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var $874d26650225b9e6$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $874d26650225b9e6$var$observers = new WeakMap();
var $874d26650225b9e6$var$fireObserverCallback = function(entry) {
    var _a;
    (_a = $874d26650225b9e6$var$observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
var $874d26650225b9e6$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($874d26650225b9e6$var$fireObserverCallback);
};
function $874d26650225b9e6$var$initIntersectionObserver(_a) {
    var root = _a.root, options = (0, $ixrLi.__rest)(_a, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$874d26650225b9e6$var$observers.has(lookupRoot)) $874d26650225b9e6$var$observers.set(lookupRoot, {});
    var rootObservers = $874d26650225b9e6$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($874d26650225b9e6$var$fireAllObserverCallbacks, (0, $ixrLi.__assign)({
        root: root
    }, options));
    return rootObservers[key];
}
function $874d26650225b9e6$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $874d26650225b9e6$var$initIntersectionObserver(options);
    $874d26650225b9e6$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $874d26650225b9e6$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});


parcelRegister("5qyn5", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", function () { return $92c877dbe8e40e92$export$46d1d6d046f826e4; });
var $92c877dbe8e40e92$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRegister("iFhJr", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $cda63e3fa02c7af4$export$7f9953c70dacfd7f; });

var $ixrLi = parcelRequire("ixrLi");

var $dvPqk = parcelRequire("dvPqk");

var $3gQWn = parcelRequire("3gQWn");

var $At31n = parcelRequire("At31n");

var $4CrdQ = parcelRequire("4CrdQ");

var $hTAy1 = parcelRequire("hTAy1");

var $jQ0wz = parcelRequire("jQ0wz");

var $5qyn5 = parcelRequire("5qyn5");
var $cda63e3fa02c7af4$export$7f9953c70dacfd7f = {
    animation: (0, $5qyn5.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $hTAy1.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $3gQWn.isAnimationControls)(animate)) (0, $dvPqk.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $5qyn5.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $ixrLi.__read)((0, $At31n.usePresence)(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = (0, $dvPqk.useContext)((0, $4CrdQ.PresenceContext));
        (0, $dvPqk.useEffect)(function() {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $jQ0wz.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};

});
parcelRegister("At31n", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $19df12151d6c7748$export$2a8c16d82a0a0e26; });

var $dvPqk = parcelRequire("dvPqk");

var $4CrdQ = parcelRequire("4CrdQ");

var $2gWXW = parcelRequire("2gWXW");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $19df12151d6c7748$export$2a8c16d82a0a0e26() {
    var context = (0, $dvPqk.useContext)((0, $4CrdQ.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    var id = (0, $2gWXW.useId)();
    (0, $dvPqk.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $19df12151d6c7748$export$8249053f690ea39a() {
    return $19df12151d6c7748$export$ee27c052bca048fb((0, $dvPqk.useContext)((0, $4CrdQ.PresenceContext)));
}
function $19df12151d6c7748$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("hTAy1", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $5158e3c6d0c391ee$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "createAnimationState", function () { return $5158e3c6d0c391ee$export$bb53502b7a672aa8; });

var $ixrLi = parcelRequire("ixrLi");

var $3gQWn = parcelRequire("3gQWn");

var $1aE8G = parcelRequire("1aE8G");

var $3wRWo = parcelRequire("3wRWo");

var $9I4gw = parcelRequire("9I4gw");

var $jQ0wz = parcelRequire("jQ0wz");

var $2qIDj = parcelRequire("2qIDj");
var $5158e3c6d0c391ee$export$16e45afcc206d3a8 = [
    (0, $jQ0wz.AnimationType).Animate,
    (0, $jQ0wz.AnimationType).InView,
    (0, $jQ0wz.AnimationType).Focus,
    (0, $jQ0wz.AnimationType).Hover,
    (0, $jQ0wz.AnimationType).Tap,
    (0, $jQ0wz.AnimationType).Drag,
    (0, $jQ0wz.AnimationType).Exit
];
var $5158e3c6d0c391ee$var$reversePriorityOrder = (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)($5158e3c6d0c391ee$export$16e45afcc206d3a8), false).reverse();
var $5158e3c6d0c391ee$var$numAnimationTypes = $5158e3c6d0c391ee$export$16e45afcc206d3a8.length;
function $5158e3c6d0c391ee$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $9I4gw.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $5158e3c6d0c391ee$export$bb53502b7a672aa8(visualElement) {
    var animate = $5158e3c6d0c391ee$var$animateList(visualElement);
    var state = $5158e3c6d0c391ee$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $2qIDj.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $ixrLi.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $ixrLi.__assign)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $5158e3c6d0c391ee$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $2qIDj.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $ixrLi.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $3gQWn.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $5158e3c6d0c391ee$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $1aE8G.isKeyframesTarget)(next) && (0, $1aE8G.isKeyframesTarget)(prev)) {
                        if (!(0, $3wRWo.shallowCompare)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $ixrLi.__assign)({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $5158e3c6d0c391ee$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $ixrLi.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(options, type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $5158e3c6d0c391ee$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $2qIDj.isVariantLabels)(next)) return !(0, $3wRWo.shallowCompare)(next, prev);
    return false;
}
function $5158e3c6d0c391ee$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $5158e3c6d0c391ee$var$createState() {
    var _a;
    return _a = {}, _a[(0, $jQ0wz.AnimationType).Animate] = $5158e3c6d0c391ee$var$createTypeState(true), _a[(0, $jQ0wz.AnimationType).InView] = $5158e3c6d0c391ee$var$createTypeState(), _a[(0, $jQ0wz.AnimationType).Hover] = $5158e3c6d0c391ee$var$createTypeState(), _a[(0, $jQ0wz.AnimationType).Tap] = $5158e3c6d0c391ee$var$createTypeState(), _a[(0, $jQ0wz.AnimationType).Drag] = $5158e3c6d0c391ee$var$createTypeState(), _a[(0, $jQ0wz.AnimationType).Focus] = $5158e3c6d0c391ee$var$createTypeState(), _a[(0, $jQ0wz.AnimationType).Exit] = $5158e3c6d0c391ee$var$createTypeState(), _a;
}

});
parcelRegister("3wRWo", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $ed992c645d0bf128$export$90e866afbd6b9f1a; });
function $ed992c645d0bf128$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("9I4gw", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $65444870a3208e00$export$ff62cf473653f109; });

var $ixrLi = parcelRequire("ixrLi");

var $i29gR = parcelRequire("i29gR");

var $flaSr = parcelRequire("flaSr");

var $2qIDj = parcelRequire("2qIDj");

var $hnWph = parcelRequire("hnWph");
function $65444870a3208e00$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $65444870a3208e00$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $65444870a3208e00$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $2qIDj.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $65444870a3208e00$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $65444870a3208e00$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $2qIDj.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $65444870a3208e00$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $65444870a3208e00$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $ixrLi.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $65444870a3208e00$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $ixrLi.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $65444870a3208e00$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $ixrLi.__assign)({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $hnWph.isTransformProp)(key)) valueTransition = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, valueTransition), {
            type: false,
            delay: 0
        });
        var animation = (0, $i29gR.startAnimation)(key, value, valueTarget, valueTransition);
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $flaSr.setTarget)(visualElement, transitionEnd);
    });
}
function $65444870a3208e00$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($65444870a3208e00$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($65444870a3208e00$var$animateVariant(child, variant, (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $65444870a3208e00$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $65444870a3208e00$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $65444870a3208e00$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRegister("i29gR", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $cc35616de95fc7ee$export$7c1391340308742e; });
$parcel$export(module.exports, "startAnimation", function () { return $cc35616de95fc7ee$export$592dbd515a49cf1b; });

var $ixrLi = parcelRequire("ixrLi");

var $9vNha = parcelRequire("9vNha");
var $k7ApB = parcelRequire("k7ApB");

var $hFbMz = parcelRequire("hFbMz");

var $fvgjy = parcelRequire("fvgjy");

var $6ikbC = parcelRequire("6ikbC");

var $1S594 = parcelRequire("1S594");

var $8a1py = parcelRequire("8a1py");

var $1AVNz = parcelRequire("1AVNz");

var $gn4oQ = parcelRequire("gn4oQ");

var $jmrkB = parcelRequire("jmrkB");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $cc35616de95fc7ee$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $ixrLi.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $cc35616de95fc7ee$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $cc35616de95fc7ee$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $ixrLi.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $ixrLi.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $hFbMz.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $hFbMz.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $fvgjy.isEasingArray)(ease) ? ease.map((0, $fvgjy.easingDefinitionToFunction)) : (0, $fvgjy.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $8a1py.warning)(!$cc35616de95fc7ee$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $cc35616de95fc7ee$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $cc35616de95fc7ee$export$b55a0e77aebddb70(transition, key) {
    var _a, _b;
    var valueTransition = $cc35616de95fc7ee$export$7c1391340308742e(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function $cc35616de95fc7ee$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function $cc35616de95fc7ee$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $cc35616de95fc7ee$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$cc35616de95fc7ee$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, transition), (0, $1S594.getDefaultTransition)(key, options.to));
    return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, options), $cc35616de95fc7ee$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $cc35616de95fc7ee$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $cc35616de95fc7ee$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $6ikbC.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $1AVNz.getAnimatableNone)(key, target);
    else if ($cc35616de95fc7ee$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $cc35616de95fc7ee$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $cc35616de95fc7ee$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $cc35616de95fc7ee$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $6ikbC.isAnimatable)(key, origin);
    (0, $8a1py.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, ' from "').concat(origin, '" to "').concat(target, '". ').concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $k7ApB.inertia)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, options), valueTransition)) : (0, $9vNha.animate)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, $cc35616de95fc7ee$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        var finalTarget = (0, $jmrkB.resolveFinalValueInKeyframes)(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $cc35616de95fc7ee$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $cc35616de95fc7ee$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $1AVNz.getAnimatableNone)("", potentialUnitType);
}
function $cc35616de95fc7ee$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function $cc35616de95fc7ee$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    if ((0, $gn4oQ.instantAnimationState).current) transition = {
        type: false
    };
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $cc35616de95fc7ee$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $cc35616de95fc7ee$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = window.setTimeout(start, (0, $hFbMz.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRegister("9vNha", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $f6650ed2d800c0b2$export$e3607ec2d7a891c4; });

var $ixrLi = parcelRequire("ixrLi");

var $248dm = parcelRequire("248dm");

var $5GUqn = parcelRequire("5GUqn");

var $dyWxM = parcelRequire("dyWxM");

var $5wUgC = parcelRequire("5wUgC");
const $f6650ed2d800c0b2$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $5GUqn.default).update(passTimestamp, true),
        stop: ()=>(0, $5GUqn.cancelSync).update(passTimestamp)
    };
};
function $f6650ed2d800c0b2$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $f6650ed2d800c0b2$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $ixrLi.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $248dm.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $dyWxM.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $5wUgC.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $5wUgC.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $5wUgC.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRegister("248dm", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", function () { return $23f5373f8d216aa3$export$74df49bbebf8cb2c; });

var $cPxzs = parcelRequire("cPxzs");

var $lIM5F = parcelRequire("lIM5F");

var $it5zw = parcelRequire("it5zw");
const $23f5373f8d216aa3$var$types = {
    keyframes: $lIM5F.keyframes,
    spring: $cPxzs.spring,
    decay: $it5zw.decay
};
function $23f5373f8d216aa3$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $lIM5F.keyframes;
    else if ($23f5373f8d216aa3$var$types[config.type]) return $23f5373f8d216aa3$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $lIM5F.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $cPxzs.spring;
    return 0, $lIM5F.keyframes;
}

});
parcelRegister("cPxzs", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $ef060e0b1ca8423a$export$b36281d89752ae66; });

var $ixrLi = parcelRequire("ixrLi");

var $5SrGt = parcelRequire("5SrGt");
const $ef060e0b1ca8423a$var$durationKeys = [
    "duration",
    "bounce"
];
const $ef060e0b1ca8423a$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $ef060e0b1ca8423a$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $ef060e0b1ca8423a$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$ef060e0b1ca8423a$var$isSpringType(options, $ef060e0b1ca8423a$var$physicsKeys) && $ef060e0b1ca8423a$var$isSpringType(options, $ef060e0b1ca8423a$var$durationKeys)) {
        const derived = (0, $5SrGt.findSpring)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $ef060e0b1ca8423a$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $ixrLi.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $ef060e0b1ca8423a$var$getSpringOptions(options);
    let resolveSpring = $ef060e0b1ca8423a$var$zero;
    let resolveVelocity = $ef060e0b1ca8423a$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $5SrGt.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$ef060e0b1ca8423a$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $ef060e0b1ca8423a$var$zero = (_t)=>0;

});
parcelRegister("5SrGt", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $763cc3e058d422ba$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $763cc3e058d422ba$export$5f679887c3a78b15; });

var $8a1py = parcelRequire("8a1py");

var $lPcCI = parcelRequire("lPcCI");
const $763cc3e058d422ba$var$safeMin = 0.001;
const $763cc3e058d422ba$export$a3cdb76e84ee608e = 0.01;
const $763cc3e058d422ba$export$1824b851fad8862b = 10.0;
const $763cc3e058d422ba$export$ff08f2d53484465 = 0.05;
const $763cc3e058d422ba$export$201ca48e54038115 = 1;
function $763cc3e058d422ba$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $8a1py.warning)(duration <= $763cc3e058d422ba$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $lPcCI.clamp)($763cc3e058d422ba$export$ff08f2d53484465, $763cc3e058d422ba$export$201ca48e54038115, dampingRatio);
    duration = (0, $lPcCI.clamp)($763cc3e058d422ba$export$a3cdb76e84ee608e, $763cc3e058d422ba$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $763cc3e058d422ba$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $763cc3e058d422ba$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $763cc3e058d422ba$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $763cc3e058d422ba$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$763cc3e058d422ba$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $763cc3e058d422ba$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $763cc3e058d422ba$var$rootIterations = 12;
function $763cc3e058d422ba$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $763cc3e058d422ba$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $763cc3e058d422ba$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRegister("lPcCI", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $337aa05aa745daff$export$7d15b64cf5a3a4c4; });
const $337aa05aa745daff$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});



parcelRegister("lIM5F", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $43432151c5a1350e$export$d25ddfdf17c3ad3e; });

var $dyWxM = parcelRequire("dyWxM");

var $qZ0TD = parcelRequire("qZ0TD");
function $43432151c5a1350e$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $qZ0TD.easeInOut)).splice(0, values.length - 1);
}
function $43432151c5a1350e$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $43432151c5a1350e$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $43432151c5a1350e$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $43432151c5a1350e$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $43432151c5a1350e$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $dyWxM.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $43432151c5a1350e$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRegister("dyWxM", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $2ec2d2fa3231e3ce$export$89e29e4ab65e70a9; });

var $cQrMp = parcelRequire("cQrMp");

var $50m78 = parcelRequire("50m78");

var $e2W8b = parcelRequire("e2W8b");

var $4CIjJ = parcelRequire("4CIjJ");

var $5kP4J = parcelRequire("5kP4J");

var $lPcCI = parcelRequire("lPcCI");

var $aLmIo = parcelRequire("aLmIo");

var $8a1py = parcelRequire("8a1py");
const $2ec2d2fa3231e3ce$var$mixNumber = (from, to)=>(p)=>(0, $50m78.mix)(from, to, p);
function $2ec2d2fa3231e3ce$var$detectMixerFactory(v) {
    if (typeof v === "number") return $2ec2d2fa3231e3ce$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $5kP4J.color).test(v)) return 0, $e2W8b.mixColor;
        else return 0, $4CIjJ.mixComplex;
    } else if (Array.isArray(v)) return 0, $4CIjJ.mixArray;
    else if (typeof v === "object") return 0, $4CIjJ.mixObject;
}
function $2ec2d2fa3231e3ce$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $2ec2d2fa3231e3ce$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $aLmIo.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $2ec2d2fa3231e3ce$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $cQrMp.progress)(from, to, v));
}
function $2ec2d2fa3231e3ce$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $cQrMp.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $2ec2d2fa3231e3ce$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $8a1py.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $8a1py.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $2ec2d2fa3231e3ce$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $2ec2d2fa3231e3ce$var$fastInterpolate(input, mixers) : $2ec2d2fa3231e3ce$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $lPcCI.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("cQrMp", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $c9eb93b631c14ef9$export$504d7abb21fa8c9; });
const $c9eb93b631c14ef9$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("50m78", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $a2a9fff404250a44$export$2c9e8a9632a706b2; });
const $a2a9fff404250a44$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;

});

parcelRegister("e2W8b", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $d627d54677daf359$export$51e568cf5c039bac; });

var $50m78 = parcelRequire("50m78");

var $eP6AW = parcelRequire("eP6AW");
var $34HJR = parcelRequire("34HJR");
var $7su29 = parcelRequire("7su29");

var $8a1py = parcelRequire("8a1py");

var $5gUsL = parcelRequire("5gUsL");
const $d627d54677daf359$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $d627d54677daf359$var$colorTypes = [
    (0, $eP6AW.hex),
    (0, $7su29.rgba),
    (0, $34HJR.hsla)
];
const $d627d54677daf359$var$getColorType = (v)=>$d627d54677daf359$var$colorTypes.find((type)=>type.test(v));
const $d627d54677daf359$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $d627d54677daf359$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $d627d54677daf359$var$getColorType(from);
    let toColorType = $d627d54677daf359$var$getColorType(to);
    (0, $8a1py.invariant)(!!fromColorType, $d627d54677daf359$var$notAnimatable(from));
    (0, $8a1py.invariant)(!!toColorType, $d627d54677daf359$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $34HJR.hsla)) {
        fromColor = (0, $5gUsL.hslaToRgba)(fromColor);
        fromColorType = (0, $7su29.rgba);
    }
    if (toColorType === (0, $34HJR.hsla)) {
        toColor = (0, $5gUsL.hslaToRgba)(toColor);
        toColorType = (0, $7su29.rgba);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $d627d54677daf359$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $50m78.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRegister("eP6AW", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $b630835dcba1fa2c$export$834dfc94dde4b3d8; });

var $7su29 = parcelRequire("7su29");

var $88Uwo = parcelRequire("88Uwo");
function $b630835dcba1fa2c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $b630835dcba1fa2c$export$834dfc94dde4b3d8 = {
    test: (0, $88Uwo.isColorString)("#"),
    parse: $b630835dcba1fa2c$var$parseHex,
    transform: (0, $7su29.rgba).transform
};

});
parcelRegister("7su29", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $a39a932c6483ab5f$export$4e46ac54fc82cf3b; });

var $h5uhF = parcelRequire("h5uhF");

var $fGmj9 = parcelRequire("fGmj9");

var $88Uwo = parcelRequire("88Uwo");
const $a39a932c6483ab5f$var$clampRgbUnit = (0, $fGmj9.clamp)(0, 255);
const $a39a932c6483ab5f$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $h5uhF.number)), {
    transform: (v)=>Math.round($a39a932c6483ab5f$var$clampRgbUnit(v))
});
const $a39a932c6483ab5f$export$4e46ac54fc82cf3b = {
    test: (0, $88Uwo.isColorString)("rgb", "red"),
    parse: (0, $88Uwo.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $a39a932c6483ab5f$export$7a99c86b5b1f4c9e.transform(red) + ", " + $a39a932c6483ab5f$export$7a99c86b5b1f4c9e.transform(green) + ", " + $a39a932c6483ab5f$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $fGmj9.sanitize)((0, $h5uhF.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("88Uwo", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $834d26386ae4434f$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $834d26386ae4434f$export$73d6f35be992df24; });

var $fGmj9 = parcelRequire("fGmj9");
const $834d26386ae4434f$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $fGmj9.isString)(v) && (0, $fGmj9.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $834d26386ae4434f$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $fGmj9.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $fGmj9.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("34HJR", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $99f52e58b5e97da0$export$810b04175080204c; });

var $h5uhF = parcelRequire("h5uhF");

var $hJuU3 = parcelRequire("hJuU3");

var $fGmj9 = parcelRequire("fGmj9");

var $88Uwo = parcelRequire("88Uwo");
const $99f52e58b5e97da0$export$810b04175080204c = {
    test: (0, $88Uwo.isColorString)("hsl", "hue"),
    parse: (0, $88Uwo.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $hJuU3.percent).transform((0, $fGmj9.sanitize)(saturation)) + ", " + (0, $hJuU3.percent).transform((0, $fGmj9.sanitize)(lightness)) + ", " + (0, $fGmj9.sanitize)((0, $h5uhF.alpha).transform(alpha$1)) + ")";
    }
};

});

parcelRegister("5gUsL", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $5c676362782bbcb9$export$6ae64dbcd6bfc33e; });
function $5c676362782bbcb9$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5c676362782bbcb9$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5c676362782bbcb9$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5c676362782bbcb9$var$hueToRgb(p, q, hue);
        blue = $5c676362782bbcb9$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});


parcelRegister("4CIjJ", function(module, exports) {

$parcel$export(module.exports, "mixComplex", function () { return $011fafb986048181$export$65516310a87d8205; });
$parcel$export(module.exports, "mixArray", function () { return $011fafb986048181$export$3bbefa2f402845c4; });
$parcel$export(module.exports, "mixObject", function () { return $011fafb986048181$export$ebc23b6840c51ba1; });

var $5kP4J = parcelRequire("5kP4J");
var $671VB = parcelRequire("671VB");

var $50m78 = parcelRequire("50m78");

var $e2W8b = parcelRequire("e2W8b");

var $eCeDL = parcelRequire("eCeDL");

var $aLmIo = parcelRequire("aLmIo");

var $8a1py = parcelRequire("8a1py");
function $011fafb986048181$var$getMixer(origin, target) {
    if ((0, $eCeDL.isNum)(origin)) return (v)=>(0, $50m78.mix)(origin, target, v);
    else if ((0, $5kP4J.color).test(origin)) return (0, $e2W8b.mixColor)(origin, target);
    else return $011fafb986048181$export$65516310a87d8205(origin, target);
}
const $011fafb986048181$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$011fafb986048181$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $011fafb986048181$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $011fafb986048181$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $011fafb986048181$var$analyse(value) {
    const parsed = (0, $671VB.complex).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $011fafb986048181$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $671VB.complex).createTransformer(target);
    const originStats = $011fafb986048181$var$analyse(origin);
    const targetStats = $011fafb986048181$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $aLmIo.pipe)($011fafb986048181$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $8a1py.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};

});
parcelRegister("5kP4J", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $0fee0838000ec515$export$35e9368ef982300f; });

var $fGmj9 = parcelRequire("fGmj9");

var $eP6AW = parcelRequire("eP6AW");

var $34HJR = parcelRequire("34HJR");

var $7su29 = parcelRequire("7su29");
const $0fee0838000ec515$export$35e9368ef982300f = {
    test: (v)=>(0, $7su29.rgba).test(v) || (0, $eP6AW.hex).test(v) || (0, $34HJR.hsla).test(v),
    parse: (v)=>{
        if ((0, $7su29.rgba).test(v)) return (0, $7su29.rgba).parse(v);
        else if ((0, $34HJR.hsla).test(v)) return (0, $34HJR.hsla).parse(v);
        else return (0, $eP6AW.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $fGmj9.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $7su29.rgba).transform(v) : (0, $34HJR.hsla).transform(v);
    }
};

});

parcelRegister("671VB", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $bccbcf22748575e8$export$83a0e34f1302825b; });

var $5kP4J = parcelRequire("5kP4J");

var $h5uhF = parcelRequire("h5uhF");

var $fGmj9 = parcelRequire("fGmj9");
const $bccbcf22748575e8$var$colorToken = "${c}";
const $bccbcf22748575e8$var$numberToken = "${n}";
function $bccbcf22748575e8$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $fGmj9.isString)(v) && ((_b = (_a = v.match((0, $fGmj9.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $fGmj9.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $bccbcf22748575e8$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $fGmj9.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $fGmj9.colorRegex), $bccbcf22748575e8$var$colorToken);
        values.push(...colors.map((0, $5kP4J.color).parse));
    }
    const numbers = v.match((0, $fGmj9.floatRegex));
    if (numbers) {
        v = v.replace((0, $fGmj9.floatRegex), $bccbcf22748575e8$var$numberToken);
        values.push(...numbers.map((0, $h5uhF.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $bccbcf22748575e8$var$parse(v) {
    return $bccbcf22748575e8$var$analyse(v).values;
}
function $bccbcf22748575e8$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $bccbcf22748575e8$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $bccbcf22748575e8$var$colorToken : $bccbcf22748575e8$var$numberToken, i < numColors ? (0, $5kP4J.color).transform(v[i]) : (0, $fGmj9.sanitize)(v[i]));
        return output;
    };
}
const $bccbcf22748575e8$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $bccbcf22748575e8$var$getAnimatableNone(v) {
    const parsed = $bccbcf22748575e8$var$parse(v);
    const transformer = $bccbcf22748575e8$var$createTransformer(v);
    return transformer(parsed.map($bccbcf22748575e8$var$convertNumbersToZero));
}
const $bccbcf22748575e8$export$83a0e34f1302825b = {
    test: $bccbcf22748575e8$var$test,
    parse: $bccbcf22748575e8$var$parse,
    createTransformer: $bccbcf22748575e8$var$createTransformer,
    getAnimatableNone: $bccbcf22748575e8$var$getAnimatableNone
};

});

parcelRegister("eCeDL", function(module, exports) {

$parcel$export(module.exports, "isNum", function () { return $4928d0322a1d25fa$export$4e960b977ccfec97; });
const $4928d0322a1d25fa$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $4928d0322a1d25fa$export$4e960b977ccfec97 = (v)=>typeof v === "number";

});



parcelRegister("qZ0TD", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $69ec4f3d06cb7064$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "easeIn", function () { return $69ec4f3d06cb7064$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $69ec4f3d06cb7064$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $69ec4f3d06cb7064$export$c07234257a03d5e9; });
$parcel$export(module.exports, "circIn", function () { return $69ec4f3d06cb7064$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $69ec4f3d06cb7064$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $69ec4f3d06cb7064$export$30d3455eee55bed5; });
$parcel$export(module.exports, "backIn", function () { return $69ec4f3d06cb7064$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $69ec4f3d06cb7064$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $69ec4f3d06cb7064$export$ddc5fd596f6c71b2; });
$parcel$export(module.exports, "anticipate", function () { return $69ec4f3d06cb7064$export$6b0af63b873d419e; });
$parcel$export(module.exports, "bounceOut", function () { return $69ec4f3d06cb7064$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceIn", function () { return $69ec4f3d06cb7064$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceInOut", function () { return $69ec4f3d06cb7064$export$41ad9e9849a703ce; });

var $OJ5nR = parcelRequire("OJ5nR");
const $69ec4f3d06cb7064$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $69ec4f3d06cb7064$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $69ec4f3d06cb7064$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $69ec4f3d06cb7064$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $69ec4f3d06cb7064$export$45db2fc2f15997e7 = (p)=>p;
const $69ec4f3d06cb7064$export$929e5a82286172a6 = (0, $OJ5nR.createExpoIn)(2);
const $69ec4f3d06cb7064$export$57636bb43b1ccbb0 = (0, $OJ5nR.reverseEasing)($69ec4f3d06cb7064$export$929e5a82286172a6);
const $69ec4f3d06cb7064$export$c07234257a03d5e9 = (0, $OJ5nR.mirrorEasing)($69ec4f3d06cb7064$export$929e5a82286172a6);
const $69ec4f3d06cb7064$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $69ec4f3d06cb7064$export$c8d67a19199d1a50 = (0, $OJ5nR.reverseEasing)($69ec4f3d06cb7064$export$e444123e42d03385);
const $69ec4f3d06cb7064$export$30d3455eee55bed5 = (0, $OJ5nR.mirrorEasing)($69ec4f3d06cb7064$export$c8d67a19199d1a50);
const $69ec4f3d06cb7064$export$b01116c84cdfe1a2 = (0, $OJ5nR.createBackIn)($69ec4f3d06cb7064$var$DEFAULT_OVERSHOOT_STRENGTH);
const $69ec4f3d06cb7064$export$77edfce482316a60 = (0, $OJ5nR.reverseEasing)($69ec4f3d06cb7064$export$b01116c84cdfe1a2);
const $69ec4f3d06cb7064$export$ddc5fd596f6c71b2 = (0, $OJ5nR.mirrorEasing)($69ec4f3d06cb7064$export$b01116c84cdfe1a2);
const $69ec4f3d06cb7064$export$6b0af63b873d419e = (0, $OJ5nR.createAnticipate)($69ec4f3d06cb7064$var$DEFAULT_OVERSHOOT_STRENGTH);
const $69ec4f3d06cb7064$var$ca = 4356.0 / 361.0;
const $69ec4f3d06cb7064$var$cb = 35442.0 / 1805.0;
const $69ec4f3d06cb7064$var$cc = 16061.0 / 1805.0;
const $69ec4f3d06cb7064$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $69ec4f3d06cb7064$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $69ec4f3d06cb7064$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $69ec4f3d06cb7064$var$BOUNCE_THIRD_THRESHOLD ? $69ec4f3d06cb7064$var$ca * p2 - $69ec4f3d06cb7064$var$cb * p + $69ec4f3d06cb7064$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $69ec4f3d06cb7064$export$fccebd7948554554 = (0, $OJ5nR.reverseEasing)($69ec4f3d06cb7064$export$cccc9e04465dce11);
const $69ec4f3d06cb7064$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $69ec4f3d06cb7064$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $69ec4f3d06cb7064$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;

});
parcelRegister("OJ5nR", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $bd0acf353aad106f$export$2c07eeff45156d4d; });
$parcel$export(module.exports, "mirrorEasing", function () { return $bd0acf353aad106f$export$f946554fb8aeaf0d; });
$parcel$export(module.exports, "createExpoIn", function () { return $bd0acf353aad106f$export$c90c8c5a3c7a5e80; });
$parcel$export(module.exports, "createBackIn", function () { return $bd0acf353aad106f$export$2a739ba6da1d1495; });
$parcel$export(module.exports, "createAnticipate", function () { return $bd0acf353aad106f$export$222fa0be41d8b537; });
const $bd0acf353aad106f$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $bd0acf353aad106f$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $bd0acf353aad106f$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $bd0acf353aad106f$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $bd0acf353aad106f$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $bd0acf353aad106f$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});



parcelRegister("it5zw", function(module, exports) {

$parcel$export(module.exports, "decay", function () { return $537f6f9dc779d8de$export$e9341ba102272ab9; });
function $537f6f9dc779d8de$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}

});


parcelRegister("5wUgC", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", function () { return $70641e01b8b064d5$export$7d0784e050d8e25f; });
$parcel$export(module.exports, "reverseElapsed", function () { return $70641e01b8b064d5$export$ab9042754680126b; });
$parcel$export(module.exports, "hasRepeatDelayElapsed", function () { return $70641e01b8b064d5$export$c9c9437f9b8733b5; });
function $70641e01b8b064d5$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $70641e01b8b064d5$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $70641e01b8b064d5$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $70641e01b8b064d5$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRegister("k7ApB", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $9bb784c99dc61cc3$export$ee3ff3a17106998; });

var $9vNha = parcelRequire("9vNha");

var $9EIpE = parcelRequire("9EIpE");

var $5GUqn = parcelRequire("5GUqn");
function $9bb784c99dc61cc3$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $9vNha.animate)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $9EIpE.velocityPerSecond)(v - prev, (0, $5GUqn.getFrameData)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}

});
parcelRegister("9EIpE", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $083fe33f436fd550$export$eab0632f7ad4f9d7; });
function $083fe33f436fd550$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("hFbMz", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $f9d0ac5357840345$export$fc3e7e8557f8c8c7; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $f9d0ac5357840345$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRegister("fvgjy", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $c6b7660dd9b9df81$export$ef97fe084f156ca4; });
$parcel$export(module.exports, "isEasingArray", function () { return $c6b7660dd9b9df81$export$216948827bbdc797; });

var $ixrLi = parcelRequire("ixrLi");

var $8a1py = parcelRequire("8a1py");

var $qZ0TD = parcelRequire("qZ0TD");
var $jaftr = parcelRequire("jaftr");
var $c6b7660dd9b9df81$var$easingLookup = {
    linear: (0, $qZ0TD.linear),
    easeIn: (0, $qZ0TD.easeIn),
    easeInOut: (0, $qZ0TD.easeInOut),
    easeOut: (0, $qZ0TD.easeOut),
    circIn: (0, $qZ0TD.circIn),
    circInOut: (0, $qZ0TD.circInOut),
    circOut: (0, $qZ0TD.circOut),
    backIn: (0, $qZ0TD.backIn),
    backInOut: (0, $qZ0TD.backInOut),
    backOut: (0, $qZ0TD.backOut),
    anticipate: (0, $qZ0TD.anticipate),
    bounceIn: (0, $qZ0TD.bounceIn),
    bounceInOut: (0, $qZ0TD.bounceInOut),
    bounceOut: (0, $qZ0TD.bounceOut)
};
var $c6b7660dd9b9df81$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $8a1py.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $ixrLi.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $jaftr.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $8a1py.invariant)($c6b7660dd9b9df81$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return $c6b7660dd9b9df81$var$easingLookup[definition];
    }
    return definition;
};
var $c6b7660dd9b9df81$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRegister("jaftr", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $3d635a2f6baad025$export$2c575fa1d20488bd; });

var $qZ0TD = parcelRequire("qZ0TD");
const $3d635a2f6baad025$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $3d635a2f6baad025$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $3d635a2f6baad025$var$c = (a1)=>3.0 * a1;
const $3d635a2f6baad025$var$calcBezier = (t, a1, a2)=>(($3d635a2f6baad025$var$a(a1, a2) * t + $3d635a2f6baad025$var$b(a1, a2)) * t + $3d635a2f6baad025$var$c(a1)) * t;
const $3d635a2f6baad025$var$getSlope = (t, a1, a2)=>3.0 * $3d635a2f6baad025$var$a(a1, a2) * t * t + 2.0 * $3d635a2f6baad025$var$b(a1, a2) * t + $3d635a2f6baad025$var$c(a1);
const $3d635a2f6baad025$var$subdivisionPrecision = 0.0000001;
const $3d635a2f6baad025$var$subdivisionMaxIterations = 10;
function $3d635a2f6baad025$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $3d635a2f6baad025$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $3d635a2f6baad025$var$subdivisionPrecision && ++i < $3d635a2f6baad025$var$subdivisionMaxIterations);
    return currentT;
}
const $3d635a2f6baad025$var$newtonIterations = 8;
const $3d635a2f6baad025$var$newtonMinSlope = 0.001;
function $3d635a2f6baad025$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $3d635a2f6baad025$var$newtonIterations; ++i){
        const currentSlope = $3d635a2f6baad025$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $3d635a2f6baad025$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $3d635a2f6baad025$var$kSplineTableSize = 11;
const $3d635a2f6baad025$var$kSampleStepSize = 1.0 / ($3d635a2f6baad025$var$kSplineTableSize - 1.0);
function $3d635a2f6baad025$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $qZ0TD.linear;
    const sampleValues = new Float32Array($3d635a2f6baad025$var$kSplineTableSize);
    for(let i = 0; i < $3d635a2f6baad025$var$kSplineTableSize; ++i)sampleValues[i] = $3d635a2f6baad025$var$calcBezier(i * $3d635a2f6baad025$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $3d635a2f6baad025$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $3d635a2f6baad025$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $3d635a2f6baad025$var$kSampleStepSize;
        const initialSlope = $3d635a2f6baad025$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $3d635a2f6baad025$var$newtonMinSlope) return $3d635a2f6baad025$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $3d635a2f6baad025$var$binarySubdivide(aX, intervalStart, intervalStart + $3d635a2f6baad025$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $3d635a2f6baad025$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("6ikbC", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $56e5ca39673d8881$export$65676b58b122bc38; });

var $671VB = parcelRequire("671VB");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $56e5ca39673d8881$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $671VB.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("1S594", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $8cd1ce96956702a0$export$262124b154b9f1c0; });

var $ixrLi = parcelRequire("ixrLi");

var $1aE8G = parcelRequire("1aE8G");
var $8cd1ce96956702a0$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    };
};
var $8cd1ce96956702a0$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $8cd1ce96956702a0$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $8cd1ce96956702a0$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $8cd1ce96956702a0$var$defaultTransitions = {
    x: $8cd1ce96956702a0$export$2577c2184b2254d3,
    y: $8cd1ce96956702a0$export$2577c2184b2254d3,
    z: $8cd1ce96956702a0$export$2577c2184b2254d3,
    rotate: $8cd1ce96956702a0$export$2577c2184b2254d3,
    rotateX: $8cd1ce96956702a0$export$2577c2184b2254d3,
    rotateY: $8cd1ce96956702a0$export$2577c2184b2254d3,
    rotateZ: $8cd1ce96956702a0$export$2577c2184b2254d3,
    scaleX: $8cd1ce96956702a0$export$a743142a31c132c,
    scaleY: $8cd1ce96956702a0$export$a743142a31c132c,
    scale: $8cd1ce96956702a0$export$a743142a31c132c,
    opacity: $8cd1ce96956702a0$export$c2d663fbb86d66d6,
    backgroundColor: $8cd1ce96956702a0$export$c2d663fbb86d66d6,
    color: $8cd1ce96956702a0$export$c2d663fbb86d66d6,
    default: $8cd1ce96956702a0$export$a743142a31c132c
};
var $8cd1ce96956702a0$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $1aE8G.isKeyframesTarget)(to)) transitionFactory = $8cd1ce96956702a0$var$keyframes;
    else transitionFactory = $8cd1ce96956702a0$var$defaultTransitions[valueKey] || $8cd1ce96956702a0$var$defaultTransitions.default;
    return (0, $ixrLi.__assign)({
        to: to
    }, transitionFactory(to));
};

});

parcelRegister("1AVNz", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $a5da608fc4ffc0cc$export$cea0cedcb94873b5; });

var $671VB = parcelRequire("671VB");
var $fmDtn = parcelRequire("fmDtn");

var $im3qK = parcelRequire("im3qK");
function $a5da608fc4ffc0cc$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $im3qK.getDefaultValueType)(key);
    if (defaultValueType !== (0, $fmDtn.filter)) defaultValueType = (0, $671VB.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRegister("fmDtn", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $1587db9f750f1236$export$3dea766d36a8935f; });

var $671VB = parcelRequire("671VB");

var $fGmj9 = parcelRequire("fGmj9");
const $1587db9f750f1236$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $1587db9f750f1236$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $fGmj9.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $1587db9f750f1236$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $1587db9f750f1236$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $1587db9f750f1236$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $671VB.complex)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($1587db9f750f1236$var$functionRegex);
        return functions ? functions.map($1587db9f750f1236$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("im3qK", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $46f731b2a7924137$export$67d1babe0338d23b; });

var $ixrLi = parcelRequire("ixrLi");

var $5kP4J = parcelRequire("5kP4J");
var $fmDtn = parcelRequire("fmDtn");

var $VgrW1 = parcelRequire("VgrW1");
/**
 * A map of default value types for common values
 */ var $46f731b2a7924137$export$98cd7c72c5a731fb = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $VgrW1.numberValueTypes)), {
    // Color props
    color: (0, $5kP4J.color),
    backgroundColor: (0, $5kP4J.color),
    outlineColor: (0, $5kP4J.color),
    fill: (0, $5kP4J.color),
    stroke: (0, $5kP4J.color),
    // Border props
    borderColor: (0, $5kP4J.color),
    borderTopColor: (0, $5kP4J.color),
    borderRightColor: (0, $5kP4J.color),
    borderBottomColor: (0, $5kP4J.color),
    borderLeftColor: (0, $5kP4J.color),
    filter: (0, $fmDtn.filter),
    WebkitFilter: (0, $fmDtn.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $46f731b2a7924137$export$67d1babe0338d23b = function(key) {
    return $46f731b2a7924137$export$98cd7c72c5a731fb[key];
};

});


parcelRegister("gn4oQ", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $0150d9848fb82410$export$888a3d84909f9e3d; });
var $0150d9848fb82410$export$888a3d84909f9e3d = {
    current: false
};

});


parcelRegister("flaSr", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $78daa2dc378894cd$export$1f61c53461aff4a5; });
$parcel$export(module.exports, "checkTargetForNewValues", function () { return $78daa2dc378894cd$export$6afbed164019a54c; });
$parcel$export(module.exports, "getOrigin", function () { return $78daa2dc378894cd$export$5a759dc7a1cfb72a; });

var $ixrLi = parcelRequire("ixrLi");

var $671VB = parcelRequire("671VB");

var $daoIM = parcelRequire("daoIM");

var $gswEL = parcelRequire("gswEL");

var $jmrkB = parcelRequire("jmrkB");

var $33dRK = parcelRequire("33dRK");

var $1AVNz = parcelRequire("1AVNz");

var $kCwTH = parcelRequire("kCwTH");

var $2qIDj = parcelRequire("2qIDj");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $78daa2dc378894cd$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $33dRK.motionValue)(value));
}
function $78daa2dc378894cd$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $2qIDj.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $ixrLi.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $jmrkB.resolveFinalValueInKeyframes)(target[key]);
        $78daa2dc378894cd$var$setMotionValue(visualElement, key, value);
    }
}
function $78daa2dc378894cd$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(variantLabels), false).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $78daa2dc378894cd$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $78daa2dc378894cd$var$setVariants(child, variantLabels);
        });
    });
}
function $78daa2dc378894cd$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $78daa2dc378894cd$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $78daa2dc378894cd$var$setVariants(visualElement, [
        definition
    ]);
    else $78daa2dc378894cd$export$1f61c53461aff4a5(visualElement, definition);
}
function $78daa2dc378894cd$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $daoIM.isNumericalString)(value) || (0, $gswEL.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $kCwTH.findValueType)(value) && (0, $671VB.complex).test(targetValue)) value = (0, $1AVNz.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $33dRK.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $78daa2dc378894cd$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $78daa2dc378894cd$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $78daa2dc378894cd$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRegister("daoIM", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $2b9bc73203990b46$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $2b9bc73203990b46$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRegister("gswEL", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $c7ab5185bac226d8$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $c7ab5185bac226d8$export$ade84c85e44a6cb1 = function(v) {
    return /^0[^.\s]+$/.test(v);
};

});

parcelRegister("33dRK", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $0adee410ca954dfa$export$ce8bdc721e76545f; });

var $5GUqn = parcelRequire("5GUqn");

var $9EIpE = parcelRequire("9EIpE");

var $5VGpD = parcelRequire("5VGpD");
var $0adee410ca954dfa$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $0adee410ca954dfa$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "6.5.1";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $5VGpD.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $5VGpD.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $5VGpD.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $5GUqn.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $5GUqn.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $5GUqn.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $0adee410ca954dfa$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $9EIpE.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
function $0adee410ca954dfa$export$ce8bdc721e76545f(init) {
    return new $0adee410ca954dfa$export$8cea36d14ee64562(init);
}

});
parcelRegister("5VGpD", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $fafbb5fbb9dfc9bd$export$e7dff9482a5fd23c; });

var $9l2Cy = parcelRequire("9l2Cy");
var $fafbb5fbb9dfc9bd$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $9l2Cy.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $9l2Cy.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRegister("9l2Cy", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $c5437f5a679cb892$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $c5437f5a679cb892$export$fe2d9b4e03920b4c; });

var $ixrLi = parcelRequire("ixrLi");
function $c5437f5a679cb892$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $c5437f5a679cb892$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
// Adapted from array-move
function $c5437f5a679cb892$export$ec937e64de6c1257(_a, fromIndex, toIndex) {
    var _b = (0, $ixrLi.__read)(_a), arr = _b.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _c = (0, $ixrLi.__read)(arr.splice(fromIndex, 1), 1), item = _c[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});



parcelRegister("kCwTH", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $79d454a24e668800$export$950e7e59ea1ffed7; });

var $ixrLi = parcelRequire("ixrLi");

var $5kP4J = parcelRequire("5kP4J");
var $671VB = parcelRequire("671VB");

var $kY6Mj = parcelRequire("kY6Mj");

var $3AVqb = parcelRequire("3AVqb");
/**
 * A list of all ValueTypes
 */ var $79d454a24e668800$var$valueTypes = (0, $ixrLi.__spreadArray)((0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)((0, $kY6Mj.dimensionValueTypes)), false), [
    (0, $5kP4J.color),
    (0, $671VB.complex)
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var $79d454a24e668800$export$950e7e59ea1ffed7 = function(v) {
    return $79d454a24e668800$var$valueTypes.find((0, $3AVqb.testValueType)(v));
};

});
parcelRegister("kY6Mj", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $6f90ffc0b8cac369$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $6f90ffc0b8cac369$export$eefdd52e3ccae428; });

var $hJuU3 = parcelRequire("hJuU3");
var $h5uhF = parcelRequire("h5uhF");

var $3AVqb = parcelRequire("3AVqb");

var $12Vu4 = parcelRequire("12Vu4");
/**
 * A list of value types commonly used for dimensions
 */ var $6f90ffc0b8cac369$export$d176691c1998a1f5 = [
    (0, $h5uhF.number),
    (0, $hJuU3.px),
    (0, $hJuU3.percent),
    (0, $hJuU3.degrees),
    (0, $hJuU3.vw),
    (0, $hJuU3.vh),
    (0, $12Vu4.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $6f90ffc0b8cac369$export$eefdd52e3ccae428 = function(v) {
    return $6f90ffc0b8cac369$export$d176691c1998a1f5.find((0, $3AVqb.testValueType)(v));
};

});
parcelRegister("3AVqb", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $b2c5e4181f1b46f5$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $b2c5e4181f1b46f5$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRegister("12Vu4", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $d8026fbf0f9217f0$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $d8026fbf0f9217f0$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRegister("6LR49", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $fdbfc7b6c85327a0$export$d7d5d435647ed5a0; });

var $eBhj7 = parcelRequire("eBhj7");

var $aYX7i = parcelRequire("aYX7i");

var $5qyn5 = parcelRequire("5qyn5");
var $fdbfc7b6c85327a0$export$d7d5d435647ed5a0 = {
    pan: (0, $5qyn5.makeRenderlessComponent)((0, $aYX7i.usePanGesture)),
    drag: (0, $5qyn5.makeRenderlessComponent)((0, $eBhj7.useDrag))
};

});
parcelRegister("eBhj7", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $7343950e86ecf809$export$7941f8aafa4b6021; });

var $dvPqk = parcelRequire("dvPqk");

var $cWa8I = parcelRequire("cWa8I");

var $eCBBK = parcelRequire("eCBBK");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $7343950e86ecf809$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = (0, $eCBBK.useConstant)(function() {
        return new (0, $cWa8I.VisualElementDragControls)(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $dvPqk.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $dvPqk.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}

});
parcelRegister("cWa8I", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $2a92bd77884549cc$export$86bff71f18910307; });

var $ixrLi = parcelRequire("ixrLi");

var $8a1py = parcelRequire("8a1py");

var $5EIH6 = parcelRequire("5EIH6");

var $jSwNR = parcelRequire("jSwNR");

var $do7qJ = parcelRequire("do7qJ");

var $rMFdN = parcelRequire("rMFdN");

var $3G2kW = parcelRequire("3G2kW");

var $jQ0wz = parcelRequire("jQ0wz");

var $bXYUb = parcelRequire("bXYUb");

var $9v2Z4 = parcelRequire("9v2Z4");

var $2B9Wz = parcelRequire("2B9Wz");

var $boIG2 = parcelRequire("boIG2");

var $i29gR = parcelRequire("i29gR");

var $x26ai = parcelRequire("x26ai");

var $imjsK = parcelRequire("imjsK");

var $50m78 = parcelRequire("50m78");

var $hJuU3 = parcelRequire("hJuU3");

var $2VGuT = parcelRequire("2VGuT");
var $2a92bd77884549cc$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var $2a92bd77884549cc$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $bXYUb.createBox)();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            if (snapToCursor) _this.snapToCursor((0, $boIG2.extractEventInfo)(event, "page").point);
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $jSwNR.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $9v2Z4.eachAxis)(function(axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $hJuU3.percent).test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = (0, $2VGuT.calcLength)(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $jQ0wz.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $2a92bd77884549cc$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new (0, $5EIH6.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $jQ0wz.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !$2a92bd77884549cc$var$shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $3G2kW.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && (0, $do7qJ.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $3G2kW.calcRelativeConstraints)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $3G2kW.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $9v2Z4.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $3G2kW.rebaseAxisConstraints)(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !(0, $do7qJ.isRefObject)(constraints)) return false;
        var constraintsElement = constraints.current;
        (0, $8a1py.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = (0, $2B9Wz.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = (0, $3G2kW.calcViewportConstraints)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $x26ai.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $x26ai.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = (0, $9v2Z4.eachAxis)(function(axis) {
            var _a;
            if (!$2a92bd77884549cc$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return (0, $i29gR.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        (0, $9v2Z4.eachAxis)(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        (0, $9v2Z4.eachAxis)(function(axis) {
            var drag = _this.getProps().drag;
            // If we're not dragging this axis, do an early return.
            if (!$2a92bd77884549cc$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - (0, $50m78.mix)(min, max, 0.5));
            }
        });
    };
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ VisualElementDragControls.prototype.scalePositionWithinConstraints = function() {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!(0, $do7qJ.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $9v2Z4.eachAxis)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = (0, $3G2kW.calcOrigin)({
                    min: latest,
                    max: latest
                }, _this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $9v2Z4.eachAxis)(function(axis) {
            if (!$2a92bd77884549cc$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set((0, $50m78.mix)(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        var _a;
        $2a92bd77884549cc$export$f0a15892c27dc07c.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $rMFdN.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if ((0, $do7qJ.isRefObject)(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $imjsK.addDomEvent)(window, "resize", function() {
            return _this.scalePositionWithinConstraints();
        });
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                (0, $9v2Z4.eachAxis)(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? (0, $3G2kW.defaultElastic) : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function $2a92bd77884549cc$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $2a92bd77884549cc$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("5EIH6", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $7007e04256c29c39$export$d9c66232c9c4689c; });

var $ixrLi = parcelRequire("ixrLi");

var $eFGHg = parcelRequire("eFGHg");

var $boIG2 = parcelRequire("boIG2");

var $5GUqn = parcelRequire("5GUqn");

var $hFbMz = parcelRequire("hFbMz");

var $rMFdN = parcelRequire("rMFdN");

var $4JnHO = parcelRequire("4JnHO");
var $aLmIo = parcelRequire("aLmIo");
/**
 * @internal
 */ var $7007e04256c29c39$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $7007e04256c29c39$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $4JnHO.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $5GUqn.getFrameData)().timestamp;
            _this.history.push((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $7007e04256c29c39$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $eFGHg.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $5GUqn.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $7007e04256c29c39$var$getPanInfo($7007e04256c29c39$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $eFGHg.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $boIG2.extractEventInfo)(event);
        var initialInfo = $7007e04256c29c39$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $5GUqn.getFrameData)().timestamp;
        this.history = [
            (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $7007e04256c29c39$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $aLmIo.pipe)((0, $rMFdN.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $rMFdN.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $rMFdN.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $5GUqn.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $7007e04256c29c39$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $7007e04256c29c39$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $7007e04256c29c39$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $7007e04256c29c39$var$subtractPoint(point, $7007e04256c29c39$var$lastDevicePoint(history)),
        offset: $7007e04256c29c39$var$subtractPoint(point, $7007e04256c29c39$var$startDevicePoint(history)),
        velocity: $7007e04256c29c39$var$getVelocity(history, 0.1)
    };
}
function $7007e04256c29c39$var$startDevicePoint(history) {
    return history[0];
}
function $7007e04256c29c39$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $7007e04256c29c39$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $7007e04256c29c39$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $hFbMz.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("4JnHO", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $9a3ecf8aec0cf61b$export$9f17032d917177de; });

var $bVJO2 = parcelRequire("bVJO2");

var $dCsdw = parcelRequire("dCsdw");

var $eCeDL = parcelRequire("eCeDL");
const $9a3ecf8aec0cf61b$var$distance1D = (a, b)=>Math.abs(a - b);
function $9a3ecf8aec0cf61b$export$9f17032d917177de(a, b) {
    if ((0, $eCeDL.isNum)(a) && (0, $eCeDL.isNum)(b)) return $9a3ecf8aec0cf61b$var$distance1D(a, b);
    else if ((0, $bVJO2.isPoint)(a) && (0, $bVJO2.isPoint)(b)) {
        const xDelta = $9a3ecf8aec0cf61b$var$distance1D(a.x, b.x);
        const yDelta = $9a3ecf8aec0cf61b$var$distance1D(a.y, b.y);
        const zDelta = (0, $dCsdw.isPoint3D)(a) && (0, $dCsdw.isPoint3D)(b) ? $9a3ecf8aec0cf61b$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRegister("bVJO2", function(module, exports) {

$parcel$export(module.exports, "isPoint", function () { return $ba8a3e8488d46647$export$aff838a5553f2a92; });
const $ba8a3e8488d46647$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");

});

parcelRegister("dCsdw", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", function () { return $bec09d2f411d5c4a$export$319d74662aaa2966; });

var $bVJO2 = parcelRequire("bVJO2");
const $bec09d2f411d5c4a$export$319d74662aaa2966 = (point)=>(0, $bVJO2.isPoint)(point) && point.hasOwnProperty("z");

});



parcelRegister("3G2kW", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $568fe672da9f3c0a$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $568fe672da9f3c0a$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $568fe672da9f3c0a$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $568fe672da9f3c0a$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $568fe672da9f3c0a$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $568fe672da9f3c0a$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $568fe672da9f3c0a$export$7c5eaef8f4723d22; });

var $ixrLi = parcelRequire("ixrLi");

var $lPcCI = parcelRequire("lPcCI");
var $50m78 = parcelRequire("50m78");
var $cQrMp = parcelRequire("cQrMp");

var $2VGuT = parcelRequire("2VGuT");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $568fe672da9f3c0a$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $50m78.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $50m78.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $568fe672da9f3c0a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $568fe672da9f3c0a$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $568fe672da9f3c0a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $568fe672da9f3c0a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $568fe672da9f3c0a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $ixrLi.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $568fe672da9f3c0a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $568fe672da9f3c0a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $568fe672da9f3c0a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $568fe672da9f3c0a$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $2VGuT.calcLength)(source);
    var targetLength = (0, $2VGuT.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $cQrMp.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $cQrMp.progress)(source.min, source.max - targetLength, target.min);
    return (0, $lPcCI.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $568fe672da9f3c0a$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $568fe672da9f3c0a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $568fe672da9f3c0a$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === void 0) dragElastic = $568fe672da9f3c0a$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $568fe672da9f3c0a$export$a3366d3bac43a742;
    return {
        x: $568fe672da9f3c0a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $568fe672da9f3c0a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $568fe672da9f3c0a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $568fe672da9f3c0a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $568fe672da9f3c0a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $568fe672da9f3c0a$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});
parcelRegister("2VGuT", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $cde302fa27c8bad3$export$c1c127004b72a37; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $cde302fa27c8bad3$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $cde302fa27c8bad3$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $cde302fa27c8bad3$export$2785bfcc929c5650; });

var $4JnHO = parcelRequire("4JnHO");
var $50m78 = parcelRequire("50m78");
function $cde302fa27c8bad3$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $cde302fa27c8bad3$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $4JnHO.distance)(value, target) < maxDistance;
}
function $cde302fa27c8bad3$export$e90fc1ae5e3e48ed(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $50m78.mix)(source.min, source.max, delta.origin);
    delta.scale = $cde302fa27c8bad3$export$c1c127004b72a37(target) / $cde302fa27c8bad3$export$c1c127004b72a37(source);
    if ($cde302fa27c8bad3$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $50m78.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($cde302fa27c8bad3$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $cde302fa27c8bad3$export$c0d25e96fc67d310(delta, source, target, origin) {
    $cde302fa27c8bad3$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $cde302fa27c8bad3$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $cde302fa27c8bad3$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $cde302fa27c8bad3$export$c1c127004b72a37(relative);
}
function $cde302fa27c8bad3$export$426154f9d100f99(target, relative, parent) {
    $cde302fa27c8bad3$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $cde302fa27c8bad3$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $cde302fa27c8bad3$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $cde302fa27c8bad3$export$c1c127004b72a37(layout);
}
function $cde302fa27c8bad3$export$2785bfcc929c5650(target, layout, parent) {
    $cde302fa27c8bad3$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $cde302fa27c8bad3$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("bXYUb", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $3566d22fbf599831$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $3566d22fbf599831$export$6459fc9e86be362e; });
var $3566d22fbf599831$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $3566d22fbf599831$export$3d227df54007d73a = function() {
    return {
        x: $3566d22fbf599831$export$ff25708b37f72782(),
        y: $3566d22fbf599831$export$ff25708b37f72782()
    };
};
var $3566d22fbf599831$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $3566d22fbf599831$export$6459fc9e86be362e = function() {
    return {
        x: $3566d22fbf599831$export$6db76765312617ac(),
        y: $3566d22fbf599831$export$6db76765312617ac()
    };
};

});

parcelRegister("9v2Z4", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $1520e6f755f378d1$export$b789de563eb43b1; });
function $1520e6f755f378d1$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("2B9Wz", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $96c75ac0a9ae4c4e$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $96c75ac0a9ae4c4e$export$6a597be7a7940a96; });

var $x26ai = parcelRequire("x26ai");

var $3vtYW = parcelRequire("3vtYW");
function $96c75ac0a9ae4c4e$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $x26ai.convertBoundingBoxToBox)((0, $x26ai.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $96c75ac0a9ae4c4e$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $96c75ac0a9ae4c4e$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $3vtYW.translateAxis)(viewportBox.x, scroll.x);
        (0, $3vtYW.translateAxis)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}

});
parcelRegister("x26ai", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $49ed71fb4bc29772$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $49ed71fb4bc29772$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $49ed71fb4bc29772$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $49ed71fb4bc29772$export$d3955c6a8f65a36b(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $49ed71fb4bc29772$export$b6b9cd4198191a47(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $49ed71fb4bc29772$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("3vtYW", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $a809dac40017e8fc$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $a809dac40017e8fc$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $a809dac40017e8fc$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $a809dac40017e8fc$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $a809dac40017e8fc$export$a807a5ce5ebb3895; });

var $ixrLi = parcelRequire("ixrLi");

var $50m78 = parcelRequire("50m78");

var $lRDbY = parcelRequire("lRDbY");
/**
 * Scales a point based on a factor and an originPoint
 */ function $a809dac40017e8fc$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $a809dac40017e8fc$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $a809dac40017e8fc$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $a809dac40017e8fc$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $a809dac40017e8fc$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $a809dac40017e8fc$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a809dac40017e8fc$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $a809dac40017e8fc$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $a809dac40017e8fc$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $a809dac40017e8fc$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $a809dac40017e8fc$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $a809dac40017e8fc$export$58b16271041fbfb(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $a809dac40017e8fc$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $lRDbY.hasTransform)(node.latestValues)) $a809dac40017e8fc$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $a809dac40017e8fc$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $a809dac40017e8fc$export$625f1dd140a2f5e7(axis, transforms, _a) {
    var _b = (0, $ixrLi.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $50m78.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $a809dac40017e8fc$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $a809dac40017e8fc$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $a809dac40017e8fc$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $a809dac40017e8fc$export$58b16271041fbfb(box, transform) {
    $a809dac40017e8fc$export$625f1dd140a2f5e7(box.x, transform, $a809dac40017e8fc$var$xKeys);
    $a809dac40017e8fc$export$625f1dd140a2f5e7(box.y, transform, $a809dac40017e8fc$var$yKeys);
}

});
parcelRegister("lRDbY", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $9fee7badd693419b$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $9fee7badd693419b$export$a545127cf1fbb600; });
function $9fee7badd693419b$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9fee7badd693419b$export$bdf30dca883ea463(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !$9fee7badd693419b$var$isIdentityScale(scale) || !$9fee7badd693419b$var$isIdentityScale(scaleX) || !$9fee7badd693419b$var$isIdentityScale(scaleY);
}
function $9fee7badd693419b$export$a545127cf1fbb600(values) {
    return $9fee7badd693419b$export$bdf30dca883ea463(values) || $9fee7badd693419b$var$hasTranslate(values.x) || $9fee7badd693419b$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $9fee7badd693419b$var$hasTranslate(value) {
    return value && value !== "0%";
}

});





parcelRegister("aYX7i", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", function () { return $8c51111c385ba57f$export$eb0f62174cac1aec; });

var $dvPqk = parcelRequire("dvPqk");

var $9tqH6 = parcelRequire("9tqH6");

var $7lgsu = parcelRequire("7lgsu");

var $rMFdN = parcelRequire("rMFdN");

var $5EIH6 = parcelRequire("5EIH6");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $8c51111c385ba57f$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $dvPqk.useRef)(null);
    var transformPagePoint = (0, $dvPqk.useContext)((0, $9tqH6.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $dvPqk.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $5EIH6.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $rMFdN.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $7lgsu.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRegister("eKjSu", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $177beb9f5de70195$export$56ba0183203348f5; });

var $iFeGm = parcelRequire("iFeGm");

var $cz5Nj = parcelRequire("cz5Nj");

var $8uGvj = parcelRequire("8uGvj");
var $177beb9f5de70195$export$56ba0183203348f5 = function(Component, options) {
    return (0, $8uGvj.isSVGComponent)(Component) ? (0, $cz5Nj.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $iFeGm.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("iFeGm", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", function () { return $191acb79e7ab1960$export$985b1494d4aeee90; });
$parcel$export(module.exports, "htmlVisualElement", function () { return $191acb79e7ab1960$export$9509f7c142585e92; });

var $ixrLi = parcelRequire("ixrLi");

var $eZrbx = parcelRequire("eZrbx");

var $flaSr = parcelRequire("flaSr");

var $7Oa8X = parcelRequire("7Oa8X");

var $99KN0 = parcelRequire("99KN0");

var $2Ev8A = parcelRequire("2Ev8A");

var $hnWph = parcelRequire("hnWph");

var $hsvVs = parcelRequire("hsvVs");

var $85Lqx = parcelRequire("85Lqx");

var $im3qK = parcelRequire("im3qK");

var $2B9Wz = parcelRequire("2B9Wz");
function $191acb79e7ab1960$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $191acb79e7ab1960$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $hnWph.isTransformProp)(key)) {
            var defaultType = (0, $im3qK.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $191acb79e7ab1960$export$3735103072e4a80(domElement);
            return ((0, $99KN0.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $2B9Wz.measureViewportBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $ixrLi.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $flaSr.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $flaSr.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $2Ev8A.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $ixrLi.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $hsvVs.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $7Oa8X.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $85Lqx.renderHTML)
};
var $191acb79e7ab1960$export$9509f7c142585e92 = (0, $eZrbx.visualElement)($191acb79e7ab1960$export$985b1494d4aeee90);

});
parcelRegister("eZrbx", function(module, exports) {

$parcel$export(module.exports, "visualElement", function () { return $56990c64a27ebec2$export$5ad594e944c33d76; });

var $ixrLi = parcelRequire("ixrLi");

var $5GUqn = parcelRequire("5GUqn");

var $33dRK = parcelRequire("33dRK");

var $jVe7Z = parcelRequire("jVe7Z");

var $hTAy1 = parcelRequire("hTAy1");

var $64Nu6 = parcelRequire("64Nu6");

var $exGaq = parcelRequire("exGaq");

var $2qIDj = parcelRequire("2qIDj");
var $56990c64a27ebec2$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState, shouldReduceMotion = _a.shouldReduceMotion;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = (0, $64Nu6.createLifecycles)();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $ixrLi.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $5GUqn.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $jVe7Z.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $2qIDj.checkIfControllingVariants)(props);
        var isVariantNode = (0, $2qIDj.checkIfVariantNode)(props);
        var element = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach(function(value, key) {
                    return bindToMotionValue(key, value);
                });
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $5GUqn.cancelSync).update(update);
                (0, $5GUqn.cancelSync).render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $33dRK.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $jVe7Z.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $5GUqn.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $exGaq.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $56990c64a27ebec2$var$numVariantProps; i++){
                    var name_1 = $56990c64a27ebec2$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $2qIDj.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var $56990c64a27ebec2$var$variantProps = (0, $ixrLi.__spreadArray)([
    "initial"
], (0, $ixrLi.__read)((0, $hTAy1.variantPriorityOrder)), false);
var $56990c64a27ebec2$var$numVariantProps = $56990c64a27ebec2$var$variantProps.length;

});
parcelRegister("64Nu6", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", function () { return $7e8b0094f2b299d5$export$f6841af6ea5003ab; });

var $ixrLi = parcelRequire("ixrLi");

var $5VGpD = parcelRequire("5VGpD");
var $7e8b0094f2b299d5$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $7e8b0094f2b299d5$export$f6841af6ea5003ab() {
    var managers = $7e8b0094f2b299d5$var$names.map(function() {
        return new (0, $5VGpD.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            $7e8b0094f2b299d5$var$names.forEach(function(name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $7e8b0094f2b299d5$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $7e8b0094f2b299d5$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(args), false));
        };
    });
    return lifecycles;
}

});

parcelRegister("exGaq", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $db57a81c99305ca7$export$9a552858d5197f6e; });


var $33dRK = parcelRequire("33dRK");

var $jVe7Z = parcelRequire("jVe7Z");
function $db57a81c99305ca7$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $jVe7Z.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $jVe7Z.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $33dRK.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $33dRK.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});


parcelRegister("2Ev8A", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", function () { return $1896c283ef219611$export$5849e743e29831d6; });

var $4jfSR = parcelRequire("4jfSR");

var $5gdhS = parcelRequire("5gdhS");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $1896c283ef219611$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $4jfSR.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $5gdhS.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("4jfSR", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", function () { return $a8dd1dcab082b9de$export$f7c0a352d8ef6313; });
$parcel$export(module.exports, "resolveCSSVariables", function () { return $a8dd1dcab082b9de$export$669319b042b57350; });

var $ixrLi = parcelRequire("ixrLi");

var $8a1py = parcelRequire("8a1py");
function $a8dd1dcab082b9de$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $a8dd1dcab082b9de$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $a8dd1dcab082b9de$export$b9f0c1f373aee2b0(current) {
    var match = $a8dd1dcab082b9de$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $ixrLi.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $a8dd1dcab082b9de$var$maxDepth = 4;
function $a8dd1dcab082b9de$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $8a1py.invariant)(depth <= $a8dd1dcab082b9de$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
    var _a = (0, $ixrLi.__read)($a8dd1dcab082b9de$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($a8dd1dcab082b9de$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $a8dd1dcab082b9de$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $a8dd1dcab082b9de$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $ixrLi.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $ixrLi.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$a8dd1dcab082b9de$var$isCSSVariable(current)) return;
        var resolved = $a8dd1dcab082b9de$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$a8dd1dcab082b9de$var$isCSSVariable(current)) continue;
        var resolved = $a8dd1dcab082b9de$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});

parcelRegister("5gdhS", function(module, exports) {

$parcel$export(module.exports, "unitConversion", function () { return $28aac00028634f1e$export$9e04b0cab841a28; });

var $ixrLi = parcelRequire("ixrLi");

var $h5uhF = parcelRequire("h5uhF");
var $hJuU3 = parcelRequire("hJuU3");

var $1aE8G = parcelRequire("1aE8G");

var $8a1py = parcelRequire("8a1py");

var $hnWph = parcelRequire("hnWph");

var $kY6Mj = parcelRequire("kY6Mj");
var $28aac00028634f1e$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $28aac00028634f1e$var$isPositionalKey = function(key) {
    return $28aac00028634f1e$var$positionalKeys.has(key);
};
var $28aac00028634f1e$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($28aac00028634f1e$var$isPositionalKey);
};
var $28aac00028634f1e$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $28aac00028634f1e$var$isNumOrPxType = function(v) {
    return v === (0, $h5uhF.number) || v === (0, $hJuU3.px);
};
var $28aac00028634f1e$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($28aac00028634f1e$export$d0c75e4fa9e69db8 || ($28aac00028634f1e$export$d0c75e4fa9e69db8 = {}));
var $28aac00028634f1e$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $28aac00028634f1e$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $28aac00028634f1e$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $28aac00028634f1e$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $28aac00028634f1e$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $28aac00028634f1e$var$nonTranslationalTransformKeys = (0, $hnWph.transformProps).filter(function(key) {
    return !$28aac00028634f1e$var$transformKeys.has(key);
});
function $28aac00028634f1e$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $28aac00028634f1e$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $28aac00028634f1e$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $28aac00028634f1e$var$getTranslateFromMatrix(4, 13),
    y: $28aac00028634f1e$var$getTranslateFromMatrix(5, 14)
};
var $28aac00028634f1e$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach(function(key) {
        origin[key] = $28aac00028634f1e$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $28aac00028634f1e$var$setAndResetVelocity(value, origin[key]);
        target[key] = $28aac00028634f1e$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $28aac00028634f1e$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $ixrLi.__assign)({}, target);
    transitionEnd = (0, $ixrLi.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($28aac00028634f1e$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var fromType = (0, $kY6Mj.findDimensionValueType)(from);
        var to = target[key];
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $1aE8G.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $kY6Mj.findDimensionValueType)(from);
            for(var i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $kY6Mj.findDimensionValueType)(to[i]);
                (0, $8a1py.invariant)(toType === fromType || $28aac00028634f1e$var$isNumOrPxType(fromType) && $28aac00028634f1e$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $8a1py.invariant)((0, $kY6Mj.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $kY6Mj.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($28aac00028634f1e$var$isNumOrPxType(fromType) && $28aac00028634f1e$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $hJuU3.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $28aac00028634f1e$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $28aac00028634f1e$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        var convertedTarget = $28aac00028634f1e$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $ixrLi.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if (scrollY_1 !== null) window.scrollTo({
            top: scrollY_1
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $28aac00028634f1e$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $28aac00028634f1e$var$hasPositionalKey(target) ? $28aac00028634f1e$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("cz5Nj", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", function () { return $c7c1d835a1719c19$export$3ba8992de7b705bc; });

var $ixrLi = parcelRequire("ixrLi");

var $eZrbx = parcelRequire("eZrbx");

var $gRbv0 = parcelRequire("gRbv0");

var $iFeGm = parcelRequire("iFeGm");

var $DipmX = parcelRequire("DipmX");

var $58YXb = parcelRequire("58YXb");

var $6bg86 = parcelRequire("6bg86");

var $hnWph = parcelRequire("hnWph");

var $12TDz = parcelRequire("12TDz");

var $im3qK = parcelRequire("im3qK");
var $c7c1d835a1719c19$export$3ba8992de7b705bc = (0, $eZrbx.visualElement)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $iFeGm.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $hnWph.isTransformProp)(key)) return ((_a = (0, $im3qK.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $6bg86.camelCaseAttributes).has(key) ? (0, $58YXb.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $gRbv0.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, options, props) {
        (0, $DipmX.buildSVGAttrs)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $12TDz.renderSVG)
}));

});


parcelRegister("gELO0", function(module, exports) {

$parcel$export(module.exports, "layoutFeatures", function () { return $5fc4242f70af2599$export$518df03f164c507; });

var $fblJJ = parcelRequire("fblJJ");
var $5fc4242f70af2599$export$518df03f164c507 = {
    measureLayout: (0, $fblJJ.MeasureLayout)
};

});
parcelRegister("fblJJ", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $1c3bf47dd5fd9464$export$779f5fb01ad751cd; });

var $ixrLi = parcelRequire("ixrLi");

var $5GUqn = parcelRequire("5GUqn");

var $dvPqk = parcelRequire("dvPqk");

var $At31n = parcelRequire("At31n");

var $5FwIO = parcelRequire("5FwIO");

var $bJXtv = parcelRequire("bJXtv");

var $c1xBr = parcelRequire("c1xBr");

var $jM1yR = parcelRequire("jM1yR");

var $iPTKc = parcelRequire("iPTKc");

var $HsryT = parcelRequire("HsryT");
var $1c3bf47dd5fd9464$var$MeasureLayoutWithContext = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        (0, $HsryT.addScaleCorrector)($1c3bf47dd5fd9464$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        (0, $c1xBr.globalProjectionState).hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $5GUqn.default).postRender(function() {
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) _this.safeToRemove();
            });
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Component);
function $1c3bf47dd5fd9464$export$779f5fb01ad751cd(props) {
    var _a = (0, $ixrLi.__read)((0, $At31n.usePresence)(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, $dvPqk.useContext)((0, $5FwIO.LayoutGroupContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($1c3bf47dd5fd9464$var$MeasureLayoutWithContext, (0, $ixrLi.__assign)({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $dvPqk.useContext)((0, $bJXtv.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $1c3bf47dd5fd9464$var$defaultScaleCorrectors = {
    borderRadius: (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $jM1yR.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $jM1yR.correctBorderRadius),
    borderTopRightRadius: (0, $jM1yR.correctBorderRadius),
    borderBottomLeftRadius: (0, $jM1yR.correctBorderRadius),
    borderBottomRightRadius: (0, $jM1yR.correctBorderRadius),
    boxShadow: (0, $iPTKc.correctBoxShadow)
};

});
parcelRegister("jM1yR", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $3a5ccabc7bf47bff$export$5eafb6257a5844c; });

var $hJuU3 = parcelRequire("hJuU3");
function $3a5ccabc7bf47bff$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $3a5ccabc7bf47bff$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $hJuU3.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $3a5ccabc7bf47bff$export$fafff692be55225d(latest, node.target.x);
        var y = $3a5ccabc7bf47bff$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

});

parcelRegister("iPTKc", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $7c565f067adb0640$export$eb0bc629e74dcf8; });

var $50m78 = parcelRequire("50m78");

var $671VB = parcelRequire("671VB");

var $4jfSR = parcelRequire("4jfSR");
var $7c565f067adb0640$var$varToken = "_$css";
var $7c565f067adb0640$export$eb0bc629e74dcf8 = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $4jfSR.cssVariableRegex), function(match) {
            cssVariables.push(match);
            return $7c565f067adb0640$var$varToken;
        });
        var shadow = (0, $671VB.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $671VB.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $50m78.mix)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace($7c565f067adb0640$var$varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};

});



parcelRegister("jYUSn", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $9fd8cd3879839af9$export$b61a9eb3dbde8858; });

var $lyFF0 = parcelRequire("lyFF0");

var $2IN3v = parcelRequire("2IN3v");
var $9fd8cd3879839af9$export$b91509fcf893b648 = {
    current: undefined
};
var $9fd8cd3879839af9$export$b61a9eb3dbde8858 = (0, $lyFF0.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$9fd8cd3879839af9$export$b91509fcf893b648.current) {
            var documentNode = new (0, $2IN3v.DocumentProjectionNode)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $9fd8cd3879839af9$export$b91509fcf893b648.current = documentNode;
        }
        return $9fd8cd3879839af9$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});

});
parcelRegister("lyFF0", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $317f214cc2d87997$export$a84b61f69daa9da0; });

var $ixrLi = parcelRequire("ixrLi");

var $5GUqn = parcelRequire("5GUqn");

var $50m78 = parcelRequire("50m78");

var $8GoNv = parcelRequire("8GoNv");

var $5VGpD = parcelRequire("5VGpD");

var $8Vnr3 = parcelRequire("8Vnr3");

var $6VJic = parcelRequire("6VJic");

var $3vtYW = parcelRequire("3vtYW");

var $2VGuT = parcelRequire("2VGuT");

var $4936y = parcelRequire("4936y");

var $bXYUb = parcelRequire("bXYUb");

var $i29gR = parcelRequire("i29gR");

var $f1Hgr = parcelRequire("f1Hgr");

var $7M7Ux = parcelRequire("7M7Ux");

var $HsryT = parcelRequire("HsryT");

var $bOPHw = parcelRequire("bOPHw");

var $9v2Z4 = parcelRequire("9v2Z4");

var $lRDbY = parcelRequire("lRDbY");

var $hnWph = parcelRequire("hnWph");

var $2rwjO = parcelRequire("2rwjO");

var $41Ktj = parcelRequire("41Ktj");

var $c1xBr = parcelRequire("c1xBr");
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $317f214cc2d87997$var$animationTarget = 1000;
function $317f214cc2d87997$export$a84b61f69daa9da0(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach($317f214cc2d87997$var$resolveTargetDelta);
                _this.nodes.forEach($317f214cc2d87997$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $ixrLi.__spreadArray)((0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $2rwjO.FlatTree)();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $5VGpD.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, (0, $ixrLi.__spreadArray)([], (0, $ixrLi.__read)(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
                    if ((0, $c1xBr.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $c1xBr.globalProjectionState).hasAnimatedSinceResize = false;
                        _this.nodes.forEach($317f214cc2d87997$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d, _e, _f;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                if (_this.isTreeAnimationBlocked()) {
                    _this.target = undefined;
                    _this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : $317f214cc2d87997$var$defaultLayoutTransition;
                var _g = visualElement.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $f1Hgr.boxEquals)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    var animationOptions = (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, (0, $i29gR.getValueTransition)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    _this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && _this.animationProgress === 0) _this.finishAnimation();
                    _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 || _f.call(_e));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $5GUqn.cancelSync).preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($317f214cc2d87997$var$resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout) return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($317f214cc2d87997$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($317f214cc2d87997$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($317f214cc2d87997$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($317f214cc2d87997$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($317f214cc2d87997$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $5GUqn.flushSync).update();
            (0, $5GUqn.flushSync).preRender();
            (0, $5GUqn.flushSync).render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach($317f214cc2d87997$var$clearSnapshot);
            this.sharedNodes.forEach($317f214cc2d87997$var$removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            (0, $5GUqn.default).preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $5GUqn.default).postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            $317f214cc2d87997$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            $317f214cc2d87997$var$roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $bXYUb.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !(0, $f1Hgr.isDeltaZero)(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $lRDbY.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return (0, $bXYUb.createBox)();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                (0, $3vtYW.translateAxis)(box.x, scroll.x);
                (0, $3vtYW.translateAxis)(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = (0, $bXYUb.createBox)();
            (0, $6VJic.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        (0, $6VJic.copyBoxInto)(boxWithoutScroll, box);
                        var rootScroll = this.root.scroll;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $3vtYW.translateAxis)(boxWithoutScroll.x, -rootScroll.x);
                            (0, $3vtYW.translateAxis)(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    (0, $3vtYW.translateAxis)(boxWithoutScroll.x, scroll_1.x);
                    (0, $3vtYW.translateAxis)(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
            if (transformOnly === void 0) transformOnly = false;
            var withTransforms = (0, $bXYUb.createBox)();
            (0, $6VJic.copyBoxInto)(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $3vtYW.transformBox)(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!(0, $lRDbY.hasTransform)(node.latestValues)) continue;
                (0, $3vtYW.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $lRDbY.hasTransform)(this.latestValues)) (0, $3vtYW.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = (0, $bXYUb.createBox)();
            (0, $6VJic.copyBoxInto)(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $lRDbY.hasTransform)(node.latestValues)) continue;
                (0, $lRDbY.hasScale)(node.latestValues) && node.updateSnapshot();
                var sourceBox = (0, $bXYUb.createBox)();
                var nodeBox = node.measure();
                (0, $6VJic.copyBoxInto)(sourceBox, nodeBox);
                (0, $4936y.removeBoxTransforms)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $lRDbY.hasTransform)(this.latestValues)) (0, $4936y.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = (0, $ixrLi.__assign)((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $bXYUb.createBox)();
                    this.relativeTargetOrigin = (0, $bXYUb.createBox)();
                    (0, $2VGuT.calcRelativePosition)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $6VJic.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $bXYUb.createBox)();
                this.targetWithTransforms = (0, $bXYUb.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $2VGuT.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $6VJic.copyBoxInto)(this.target, this.layout.actual);
                (0, $3vtYW.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $6VJic.copyBoxInto)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = (0, $bXYUb.createBox)();
                    this.relativeTargetOrigin = (0, $bXYUb.createBox)();
                    (0, $2VGuT.calcRelativePosition)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $6VJic.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || (0, $lRDbY.hasTransform)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $6VJic.copyBoxInto)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $3vtYW.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $bXYUb.createDelta)();
                this.projectionDeltaWithTransform = (0, $bXYUb.createDelta)();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $2VGuT.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $bOPHw.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = (0, $ixrLi.__assign)({}, this.latestValues);
            var targetDelta = (0, $bXYUb.createDelta)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = (0, $bXYUb.createBox)();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($317f214cc2d87997$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                $317f214cc2d87997$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $317f214cc2d87997$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $2VGuT.calcRelativePosition)(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    $317f214cc2d87997$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    (0, $8Vnr3.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
                _this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $5GUqn.cancelSync).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $5GUqn.default).update(function() {
                (0, $c1xBr.globalProjectionState).hasAnimatedSinceResize = true;
                _this.currentAnimation = (0, $8GoNv.animate)(0, $317f214cc2d87997$var$animationTarget, (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $317f214cc2d87997$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            (0, $6VJic.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $3vtYW.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $2VGuT.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $7M7Ux.NodeStack)());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < (0, $hnWph.transformAxes).length; i++){
                var axis = (0, $hnWph.transformAxes)[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) styleProp = {};
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $41Ktj.resolveMotionValue)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = (0, $41Ktj.resolveMotionValue)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $lRDbY.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $bOPHw.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in 0, $HsryT.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                var _h = (0, $HsryT.scaleCorrectors)[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $41Ktj.resolveMotionValue)(styleProp.pointerEvents) || "" : "none";
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($317f214cc2d87997$var$clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function $317f214cc2d87997$var$updateLayout(node) {
    node.updateLayout();
}
function $317f214cc2d87997$var$notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $9v2Z4.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $2VGuT.calcLength)(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $9v2Z4.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $2VGuT.calcLength)(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = (0, $bXYUb.createDelta)();
        (0, $2VGuT.calcBoxDelta)(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = (0, $bXYUb.createDelta)();
        if (snapshot.isShared) (0, $2VGuT.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else (0, $2VGuT.calcBoxDelta)(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !(0, $f1Hgr.isDeltaZero)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $bXYUb.createBox)();
                    (0, $2VGuT.calcRelativePosition)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = (0, $bXYUb.createBox)();
                    (0, $2VGuT.calcRelativePosition)(relativeLayout, layout_1, parentLayout.actual);
                    if (!(0, $f1Hgr.boxEquals)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $317f214cc2d87997$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $317f214cc2d87997$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $317f214cc2d87997$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function $317f214cc2d87997$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $317f214cc2d87997$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $317f214cc2d87997$var$calcProjection(node) {
    node.calcProjection();
}
function $317f214cc2d87997$var$resetRotation(node) {
    node.resetRotation();
}
function $317f214cc2d87997$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $317f214cc2d87997$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $50m78.mix)(delta.translate, 0, p);
    output.scale = (0, $50m78.mix)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $317f214cc2d87997$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $50m78.mix)(from.min, to.min, p);
    output.max = (0, $50m78.mix)(from.max, to.max, p);
}
function $317f214cc2d87997$export$6ffd3e6ae339a132(output, from, to, p) {
    $317f214cc2d87997$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $317f214cc2d87997$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $317f214cc2d87997$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $317f214cc2d87997$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $317f214cc2d87997$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector('[data-projection-id="'.concat(id, '"]'));
    if (element) node.mount(element, true);
}
function $317f214cc2d87997$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $317f214cc2d87997$var$roundBox(box) {
    $317f214cc2d87997$var$roundAxis(box.x);
    $317f214cc2d87997$var$roundAxis(box.y);
}

});
parcelRegister("8GoNv", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $48247dc63bf80503$export$e3607ec2d7a891c4; });

var $33dRK = parcelRequire("33dRK");

var $jVe7Z = parcelRequire("jVe7Z");

var $i29gR = parcelRequire("i29gR");
/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $48247dc63bf80503$export$e3607ec2d7a891c4(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = (0, $jVe7Z.isMotionValue)(from) ? from : (0, $33dRK.motionValue)(from);
    (0, $i29gR.startAnimation)("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}

});

parcelRegister("8Vnr3", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $1c9160203981792f$export$739e279c17d51c3d; });

var $qZ0TD = parcelRequire("qZ0TD");
var $50m78 = parcelRequire("50m78");
var $cQrMp = parcelRequire("cQrMp");

var $hJuU3 = parcelRequire("hJuU3");
var $1c9160203981792f$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $1c9160203981792f$var$numBorders = $1c9160203981792f$var$borders.length;
var $1c9160203981792f$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $1c9160203981792f$var$isPx = function(value) {
    return typeof value === "number" || (0, $hJuU3.px).test(value);
};
function $1c9160203981792f$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $50m78.mix)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $1c9160203981792f$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $50m78.mix)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $1c9160203981792f$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $50m78.mix)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $1c9160203981792f$var$numBorders; i++){
        var borderLabel = "border".concat($1c9160203981792f$var$borders[i], "Radius");
        var followRadius = $1c9160203981792f$var$getRadius(follow, borderLabel);
        var leadRadius = $1c9160203981792f$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $1c9160203981792f$var$isPx(followRadius) === $1c9160203981792f$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $50m78.mix)($1c9160203981792f$var$asNumber(followRadius), $1c9160203981792f$var$asNumber(leadRadius), progress), 0);
            if ((0, $hJuU3.percent).test(leadRadius) || (0, $hJuU3.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $50m78.mix)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $1c9160203981792f$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $1c9160203981792f$var$easeCrossfadeIn = $1c9160203981792f$var$compress(0, 0.5, (0, $qZ0TD.circOut));
var $1c9160203981792f$var$easeCrossfadeOut = $1c9160203981792f$var$compress(0.5, 0.95, (0, $qZ0TD.linear));
function $1c9160203981792f$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $cQrMp.progress)(min, max, p));
    };
}

});

parcelRegister("6VJic", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $d6779fbcc0c51a30$export$c53fd88f45d77e4b; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d6779fbcc0c51a30$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d6779fbcc0c51a30$export$c53fd88f45d77e4b(box, originBox) {
    $d6779fbcc0c51a30$export$a0230ae482601ae8(box.x, originBox.x);
    $d6779fbcc0c51a30$export$a0230ae482601ae8(box.y, originBox.y);
}

});

parcelRegister("4936y", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $37e9b7f079ff4c61$export$73e1ad0a9694e25c; });

var $ixrLi = parcelRequire("ixrLi");

var $50m78 = parcelRequire("50m78");

var $hJuU3 = parcelRequire("hJuU3");

var $3vtYW = parcelRequire("3vtYW");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $37e9b7f079ff4c61$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $3vtYW.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $3vtYW.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $37e9b7f079ff4c61$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if ((0, $hJuU3.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $50m78.mix)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $50m78.mix)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $37e9b7f079ff4c61$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $37e9b7f079ff4c61$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $37e9b7f079ff4c61$export$42b76f1d0d16d5b(axis, transforms, _a, origin, sourceAxis) {
    var _b = (0, $ixrLi.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $37e9b7f079ff4c61$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $37e9b7f079ff4c61$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $37e9b7f079ff4c61$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $37e9b7f079ff4c61$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $37e9b7f079ff4c61$export$42b76f1d0d16d5b(box.x, transforms, $37e9b7f079ff4c61$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $37e9b7f079ff4c61$export$42b76f1d0d16d5b(box.y, transforms, $37e9b7f079ff4c61$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

});

parcelRegister("f1Hgr", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $63e64428c714f2f3$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $63e64428c714f2f3$export$8d5cf76bb7daff09; });
function $63e64428c714f2f3$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $63e64428c714f2f3$export$a7ec7642fe550fb6(delta) {
    return $63e64428c714f2f3$var$isAxisDeltaZero(delta.x) && $63e64428c714f2f3$var$isAxisDeltaZero(delta.y);
}
function $63e64428c714f2f3$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}

});

parcelRegister("7M7Ux", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $854ff5fb194b9d25$export$39be5b2d82fc9dc7; });

var $9l2Cy = parcelRequire("9l2Cy");
var $854ff5fb194b9d25$export$39be5b2d82fc9dc7 = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        (0, $9l2Cy.addUniqueItem)(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        (0, $9l2Cy.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();

});

parcelRegister("bOPHw", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $81fe55afd7882415$export$d33653b270fe725c; });
var $81fe55afd7882415$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function $81fe55afd7882415$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform === $81fe55afd7882415$export$f6730f82d2dcfda3 ? "none" : transform;
}

});

parcelRegister("2rwjO", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $ccf78e75ce093c71$export$1465d17e3de78a96; });

var $9l2Cy = parcelRequire("9l2Cy");

var $7CaOo = parcelRequire("7CaOo");
var $ccf78e75ce093c71$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $9l2Cy.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $9l2Cy.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $7CaOo.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});
parcelRegister("7CaOo", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $51f874a7b1ee6bf1$export$d689d9dec5ad338; });
var $51f874a7b1ee6bf1$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});



parcelRegister("2IN3v", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $1aebcf57f39e4b77$export$2d029a49a09b6177; });

var $lyFF0 = parcelRequire("lyFF0");

var $imjsK = parcelRequire("imjsK");
var $1aebcf57f39e4b77$export$2d029a49a09b6177 = (0, $lyFF0.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        return (0, $imjsK.addDomEvent)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});

});



parcelRegister("dFyfh", function(module, exports) {

$parcel$export(module.exports, "translateFilterValue", function () { return $a828390aaf67501e$export$7d5d5a29852ee1bc; });

var $3xOZa = parcelRequire("3xOZa");
const $a828390aaf67501e$var$filterTranslations = {
    certifications: {
        nyt_norge: "Nyt Norge",
        nokkelhullet: "N\xf8kkelhullet",
        eu_okologi: "\xd8kologisk (EU)",
        fsc: "B\xe6rekraftig emballasje (FSC)",
        debio: "\xd8kologisk (Debio)",
        grontpunkt: "Gr\xf8nt Punkt"
    },
    brandGroup: {
        Biola: "Biola",
        Diplomis: "Diplom-is",
        Dovre: "Dovre",
        Fjordland: "Fjordland",
        GoMorgen: "Go'morgen",
        Gryr: "Gryr\xae",
        Isklar: "Isklar",
        Iste: "Iste",
        Jarlsberg: "Jarlsberg",
        Kulinaris: "Kulinaris",
        Litago: "Litago",
        Lollipop: "Lollipop",
        TINE: "TINE",
        Nicks: "Nick's",
        Noisy: "Noisy",
        Norvegia: "Norvegia",
        Royal: "Royal",
        SelbuBlaa: "Selbu Bl\xe5",
        Snofrisk: "Sn\xf8frisk",
        Sunniva: "Sunniva",
        Tonitto: "Tonitto",
        YT: "YT",
        Ostavind: "\xd8stavind",
        Other: "\xd8vrige"
    }
};
const $a828390aaf67501e$export$7d5d5a29852ee1bc = (fieldKey, fieldValue)=>{
    if (!(fieldKey in $a828390aaf67501e$var$filterTranslations) || typeof fieldValue === "undefined") {
        if (fieldKey === "sizeRange" || fieldKey === "volumeRange" || fieldKey === "weightRange") return fieldValue?.replace(/1\/2/g, "\xbd")?.replace(/1\/3/g, "\u2153")?.replace(/1\/4/g, "\xbc") ?? fieldValue;
        return fieldValue;
    }
    const translatedValues = $a828390aaf67501e$var$filterTranslations[fieldKey];
    if ((0, $3xOZa.default)(translatedValues)) return fieldValue;
    return translatedValues[fieldValue] ?? translatedValues[fieldValue.toLowerCase()] ?? fieldValue;
};

});




//# sourceMappingURL=ProductListPage.643e1c13.js.map
